import * as React from "react";

import getGenePalette from "../getGenePalette";
import GeneSnpShapes from "../shared/GeneSnpShapes";
import { geneGroupProps } from "../shared/geneGroupProps";
import getGeneSnpCount from "../shared/getGeneSnpCount";

export const CardiometabolicFatMetabolismDiagramContent = ({
  geneColors = {},
  expectedSnps = {},
  onGeneClick
}) => {
  const irs1 = getGenePalette(geneColors.IRS1);
  const pparg = getGenePalette(geneColors.PPARG);
  const adipoq = getGenePalette(geneColors.ADIPOQ);
  const apoa2 = getGenePalette(geneColors.APOA2);
  const pon1 = getGenePalette(geneColors.PON1);
  const apoc1 = getGenePalette(geneColors.APOC1);
  const apoc2 = getGenePalette(geneColors.APOC2);
  const apoc3 = getGenePalette(geneColors.APOC3);
  const apoa5 = getGenePalette(geneColors.APOA5);
  const cd36 = getGenePalette(geneColors.CD36);
  const apoe = getGenePalette(geneColors.APOE);
  const lpl = getGenePalette(geneColors.LPL);
  const ldlr = getGenePalette(geneColors.LDLR);
  const lpa = getGenePalette(geneColors.LPA);
  const apob = getGenePalette(geneColors.APOB);
  const ppara = getGenePalette(geneColors.PPARA);
  const plin1 = getGenePalette(geneColors.PLIN1);
  const adrb2 = getGenePalette(geneColors.ADRB2);
  const adrb3 = getGenePalette(geneColors.ADRB3);

  return (
    <>
      <g id="diagram" clipPath="url(#clip1_18473_208764)">
        <rect width={1024} height={1370} transform="translate(0 184)" fill="white" />
        <g id="cardiometobolic-fat metabolism-diagram">
          <rect width={1024} height={1370} transform="translate(0 184)" fill="white" />
          <path
            id="Vector_3"
            d="M327.5 1045L326.459 1053.02L333.921 1049.91L327.5 1045ZM444 1083V1083.7H444.7V1083H444ZM343.317 1083L342.671 1083.27L342.85 1083.7H343.317V1083ZM444 1083V1082.3H343.317V1083V1083.7H444V1083ZM343.317 1083L343.963 1082.73L330.567 1050.55L329.921 1050.82L329.275 1051.09L342.671 1083.27L343.317 1083ZM444 1083H444.7V1067.72H444H443.3V1083H444Z"
            fill="#282828"
          />
          <path
            id="Vector_4"
            d="M331.068 999.18L356.569 972.999L442.084 972.782V987.063V1001.35M331.068 999.18L326.833 994.461M331.068 999.18L335.715 1004"
            stroke="#E44C4B"
            strokeWidth={1.4}
          />
          <path
            id="Vector_5"
            d="M76 1361.62L75.3 1361.62L75.3 1362.32L76 1362.32L76 1361.62ZM76 460L76 459.3L75.3 459.3L75.3 460L76 460ZM510 1361.62L510.7 1361.62L510.7 1360.92L510 1360.92L510 1361.62ZM510 1411L514.041 1404L505.959 1404L510 1411ZM76 460L75.3 460L75.3 1361.62L76 1361.62L76.7 1361.62L76.7 460L76 460ZM76 460L76 460.7L124.767 460.7L124.767 460L124.767 459.3L76 459.3L76 460ZM76 1361.62L76 1362.32L510 1362.32L510 1361.62L510 1360.92L76 1360.92L76 1361.62ZM510 1361.62L509.3 1361.62L509.3 1404.7L510 1404.7L510.7 1404.7L510.7 1361.62L510 1361.62Z"
            fill="#FCCE57"
          />
          <text
            fontFamily="Gilroy W05 Medium"
            fontSize={8}
            letterSpacing="0em"
            id="ATP"
            fill="black"
            style={{ whiteSpace: "pre" }}
            xmlSpace="preserve"
          >
            <tspan x={276.947} y={1432.22}>
              ATP
            </tspan>
          </text>
          <path
            id="Vector_6"
            d="M234 910L227 905.959V914.041L234 910ZM219 910V910.7H227.7V910V909.3H219V910Z"
            fill="black"
          />
          <path
            id="Vector_7"
            d="M472.752 801.328L465.752 797.287L465.752 805.37L472.752 801.328ZM394.502 801.334L394.502 802.034L466.452 802.028L466.452 801.328L466.452 800.628L394.502 800.634L394.502 801.334Z"
            fill="black"
          />
          <path
            id="Vector_8"
            d="M630.334 807L623.334 802.959V811.041L630.334 807ZM572.334 807V807.7H624.034V807V806.3H572.334V807Z"
            fill="black"
          />
          <path
            id="Vector_9"
            d="M630.334 791L623.334 786.959V795.041L630.334 791ZM590.173 791V790.3H589.473V791H590.173ZM590.173 798V798.7H590.873V798H590.173ZM590.173 791V791.7H624.034V791V790.3H590.173V791ZM590.173 791H589.473V798H590.173H590.873V791H590.173ZM590.173 798V797.3H572.334V798V798.7H590.173V798Z"
            fill="black"
          />
          <path
            id="Vector_10"
            d="M630.334 824L623.334 828.041V819.959L630.334 824ZM590.173 824V824.7H589.473V824H590.173ZM590.173 816V815.3H590.873V816H590.173ZM590.173 824V823.3H624.034V824V824.7H590.173V824ZM590.173 824H589.473V816H590.173H590.873V824H590.173ZM590.173 816V816.7H572.334V816V815.3H590.173V816Z"
            fill="black"
          />
          <path
            id="Vector_11"
            d="M356.334 802L349.334 797.959V806.041L356.334 802ZM334.334 802V802.7H350.034V802V801.3H334.334V802Z"
            fill="black"
          />
          <path
            id="Vector_12"
            d="M329 884L324.243 877.465L320.962 884.852L329 884ZM304.235 873L304.519 872.36L304.384 872.3H304.235V873ZM295 873V873.7H304.235V873V872.3H295V873ZM304.235 873L303.951 873.64L322.958 882.082L323.242 881.443L323.527 880.803L304.519 872.36L304.235 873Z"
            fill="black"
          />
          <path
            id="Vector_13"
            d="M583.528 987L587.57 980H579.487L583.528 987ZM583.528 939.5H582.828V980.7H583.528H584.228V939.5H583.528Z"
            fill="black"
          />
          <path
            id="Vector_14"
            d="M675 993L677.693 985.379L682.947 991.522L675 993ZM685.524 984L685.07 983.468L685.266 983.3H685.524V984ZM695 984V984.7H685.524V984V983.3H695V984ZM685.524 984L685.979 984.532L680.243 989.438L679.788 988.906L679.333 988.374L685.07 983.468L685.524 984Z"
            fill="black"
          />
          <path
            id="Vector_15"
            d="M581 1054L581.317 1062.08L574.164 1058.31L581 1054ZM571.528 1072L572.147 1072.33L571.951 1072.7H571.528V1072ZM563 1072V1071.3H571.528V1072V1072.7H563V1072ZM571.528 1072L570.909 1071.67L577.447 1059.25L578.066 1059.58L578.686 1059.9L572.147 1072.33L571.528 1072Z"
            fill="black"
          />
          <path
            id="Vector_16"
            d="M665 1053L666.919 1060.85L672.759 1055.26L665 1053ZM675.524 1064L675.019 1064.48L675.225 1064.7H675.524V1064ZM685 1064V1063.3H675.524V1064V1064.7H685V1064ZM675.524 1064L676.03 1063.52L669.861 1057.07L669.355 1057.55L668.85 1058.04L675.019 1064.48L675.524 1064Z"
            fill="black"
          />
          <path
            id="Vector_17"
            d="M329 924L325.516 916.706L320.942 923.37L329 924ZM304.235 907L304.631 906.423L304.452 906.3H304.235V907ZM295 907V907.7H304.235V907V906.3H295V907ZM304.235 907L303.839 907.577L323.41 921.012L323.806 920.435L324.202 919.857L304.631 906.423L304.235 907Z"
            fill="black"
          />
          <path
            id="Vector_18"
            d="M248.334 1072L252.375 1065L244.293 1065L248.334 1072ZM248.334 1039L247.634 1039L247.634 1065.7L248.334 1065.7L249.034 1065.7L249.034 1039L248.334 1039Z"
            fill="black"
          />
          <path
            id="Vector_19"
            d="M309.334 1225L313.375 1218L305.293 1218L309.334 1225ZM309.334 1182L308.634 1182L308.634 1218.7L309.334 1218.7L310.034 1218.7L310.034 1182L309.334 1182Z"
            fill="black"
          />
          <path
            id="Vector_20"
            d="M309 1304L313.041 1297L304.959 1297L309 1304ZM309 1282L308.3 1282L308.3 1297.7L309 1297.7L309.7 1297.7L309.7 1282L309 1282Z"
            fill="black"
          />
          <path
            id="Vector_21"
            d="M246.334 1147L246.334 1147.7L247.034 1147.7L247.034 1147L246.334 1147ZM159.334 1147L166.334 1151.04L166.334 1142.96L159.334 1147ZM246.334 1105L245.634 1105L245.634 1147L246.334 1147L247.034 1147L247.034 1105L246.334 1105ZM246.334 1147L246.334 1146.3L165.634 1146.3L165.634 1147L165.634 1147.7L246.334 1147.7L246.334 1147Z"
            fill="black"
          />
          <path
            id="Vector_22"
            d="M217.334 1255L217.334 1254.3L218.034 1254.3L218.034 1255L217.334 1255ZM181.334 1255.01L188.333 1250.97L188.335 1259.05L181.334 1255.01ZM217.334 1270L216.634 1270L216.634 1255L217.334 1255L218.034 1255L218.034 1270L217.334 1270ZM217.334 1255L217.334 1255.7L187.634 1255.71L187.634 1255.01L187.634 1254.31L217.334 1254.3L217.334 1255Z"
            fill="black"
          />
          <path
            id="Vector_23"
            d="M223 1255L223 1254.3L222.3 1254.3L222.3 1255L223 1255ZM255 1255.01L248.001 1250.96L247.999 1259.05L255 1255.01ZM223 1270L223.7 1270L223.7 1255L223 1255L222.3 1255L222.3 1270L223 1270ZM223 1255L223 1255.7L248.7 1255.71L248.7 1255.01L248.7 1254.31L223 1254.3L223 1255Z"
            fill="black"
          />
          <path
            id="Vector_24"
            d="M250.334 1105L250.334 1146.65L309.334 1146.65L309.334 1176"
            stroke="black"
            strokeWidth={1.4}
          />
          <path
            id="Vector_25"
            d="M250.334 802L249.634 802L249.634 802.7L250.334 802.7L250.334 802ZM294.334 802L287.334 797.959L287.334 806.041L294.334 802ZM250.334 712L249.634 712L249.634 802L250.334 802L251.034 802L251.034 712L250.334 712ZM250.334 802L250.334 802.7L288.034 802.7L288.034 802L288.034 801.3L250.334 801.3L250.334 802Z"
            fill="black"
          />
          <path
            id="Vector_26"
            d="M276.334 960L276.334 960.7L277.034 960.7L277.034 960L276.334 960ZM173.334 960L172.634 960L172.634 960.7L173.334 960.7L173.334 960ZM276.334 934L272.293 941L280.375 941L276.334 934ZM173.334 934L169.293 941L177.375 941L173.334 934ZM173.334 960L173.334 960.7L276.334 960.7L276.334 960L276.334 959.3L173.334 959.3L173.334 960ZM276.334 960L277.034 960L277.034 940.3L276.334 940.3L275.634 940.3L275.634 960L276.334 960ZM173.334 960L174.034 960L174.034 940.3L173.334 940.3L172.634 940.3L172.634 960L173.334 960Z"
            fill="#FFC647"
          />
          <path
            id="Vector_27"
            d="M184.334 1039L191.334 1043.04L191.334 1034.96L184.334 1039ZM332.5 1039L339.5 1043.04L339.5 1034.96L332.5 1039ZM315.166 1039L315.166 1038.3L190.634 1038.3L190.634 1039L190.634 1039.7L315.166 1039.7L315.166 1039ZM396.334 1039L396.334 1038.3L338.8 1038.3L338.8 1039L338.8 1039.7L396.334 1039.7L396.334 1039Z"
            fill="black"
          />
          <path
            id="Vector_28"
            d="M453.334 1039L460.334 1043.04L460.334 1034.96L453.334 1039ZM599.334 1039L599.334 1038.3L459.634 1038.3L459.634 1039L459.634 1039.7L599.334 1039.7L599.334 1039Z"
            fill="black"
          />
          <path
            id="Vector_29"
            d="M459 889L466 893.041L466 884.959L459 889ZM584 889L584.7 889L584.7 888.3L584 888.3L584 889ZM584 889L584 888.3L465.3 888.3L465.3 889L465.3 889.7L584 889.7L584 889ZM584 889L583.3 889L583.3 923L584 923L584.7 923L584.7 889L584 889Z"
            fill="black"
          />
          <path
            id="Vector_30"
            d="M456 928L463 932.041L463 923.959L456 928ZM515 928L515.7 928L515.7 927.3L515 927.3L515 928ZM515 928L515 927.3L462.3 927.3L462.3 928L462.3 928.7L515 928.7L515 928ZM515 928L514.3 928L514.3 962L515 962L515.7 962L515.7 928L515 928Z"
            fill="black"
          />
          <path
            id="Vector_31"
            d="M219.334 1304L215.293 1311L223.375 1311L219.334 1304ZM219.334 1323L220.034 1323L220.034 1310.3L219.334 1310.3L218.634 1310.3L218.634 1323L219.334 1323Z"
            fill="black"
          />
          <path
            id="Vector_32"
            d="M528 1275L523.959 1282L532.041 1282L528 1275ZM528 1306L528.7 1306L528.7 1281.3L528 1281.3L527.3 1281.3L527.3 1306L528 1306Z"
            fill="black"
          />
          <path
            id="Vector_33"
            d="M315 1043L310.959 1050L319.041 1050L315 1043ZM315 1087H315.7L315.7 1049.3L315 1049.3L314.3 1049.3L314.3 1087H315Z"
            fill="black"
          />
          <path
            id="Vector_34"
            d="M173 370L177.041 363L168.959 363L173 370ZM173 351L172.3 351L172.3 363.7L173 363.7L173.7 363.7L173.7 351L173 351Z"
            fill="black"
          />
          <path
            id="Vector_35"
            d="M831.334 1191L827.293 1184L835.375 1184L831.334 1191ZM831.334 935L832.034 935L832.034 1184.7L831.334 1184.7L830.634 1184.7L830.634 935L831.334 935Z"
            fill="black"
          />
          <path
            id="Vector_36"
            d="M833.334 1423L833.334 1423.7L834.034 1423.7L834.034 1423L833.334 1423ZM590.334 1423L597.334 1427.04L597.334 1418.96L590.334 1423ZM833.334 1238L832.634 1238L832.634 1423L833.334 1423L834.034 1423L834.034 1238L833.334 1238ZM833.334 1423L833.334 1422.3L596.634 1422.3L596.634 1423L596.634 1423.7L833.334 1423.7L833.334 1423Z"
            fill="black"
          />
          <path
            id="Vector_37"
            d="M617.334 1047L613.293 1054L621.375 1054L617.334 1047ZM617.334 1189L618.034 1189L618.034 1053.3L617.334 1053.3L616.634 1053.3L616.634 1189L617.334 1189Z"
            fill="black"
          />
          <path
            id="Vector_38"
            d="M323.334 307.692L323.334 308.392L324.034 308.392L324.034 307.692L323.334 307.692ZM175.334 307.692L175.334 306.992L174.634 306.992L174.634 307.692L175.334 307.692ZM175.334 328L179.375 321L171.293 321L175.334 328ZM323.334 274L322.634 274L322.634 307.692L323.334 307.692L324.034 307.692L324.034 274L323.334 274ZM323.334 307.692L323.334 306.992L175.334 306.992L175.334 307.692L175.334 308.392L323.334 308.392L323.334 307.692ZM175.334 307.692L174.634 307.692L174.634 321.7L175.334 321.7L176.034 321.7L176.034 307.692L175.334 307.692Z"
            fill="black"
          />
          <path
            id="Vector_39"
            d="M625.334 595L625.334 595.7L626.034 595.7L626.034 595L625.334 595ZM625.334 486L621.292 493L629.375 493L625.334 486ZM625.334 540.5L626.034 540.5V540.5L625.334 540.5ZM387.334 595L387.334 595.7L625.334 595.7L625.334 595L625.334 594.3L387.334 594.3L387.334 595ZM625.334 595L626.034 595L626.034 540.5L625.334 540.5L624.634 540.5L624.634 595L625.334 595ZM625.334 540.5L626.034 540.5L626.034 492.3L625.334 492.3L624.634 492.3L624.634 540.5L625.334 540.5Z"
            fill="black"
          />
          <path
            id="Vector_40"
            d="M253.394 535L254.094 535L254.094 535.7L253.394 535.7L253.394 535ZM253.394 511L252.694 511L252.694 510.3L253.394 510.3L253.394 511ZM274.334 511L267.334 515.041L267.334 506.959L274.334 511ZM226.334 535L226.334 534.3L253.394 534.3L253.394 535L253.394 535.7L226.334 535.7L226.334 535ZM253.394 535L252.694 535L252.694 511L253.394 511L254.094 511L254.094 535L253.394 535ZM253.394 511L253.394 510.3L268.034 510.3L268.034 511L268.034 511.7L253.394 511.7L253.394 511Z"
            fill="black"
          />
          <path
            id="Vector_41"
            d="M253.394 539L254.094 539L254.094 538.3L253.394 538.3L253.394 539ZM253.394 562L252.694 562L252.694 562.7L253.394 562.7L253.394 562ZM274.334 562L267.334 557.959L267.334 566.041L274.334 562ZM226.334 539L226.334 539.7L253.394 539.7L253.394 539L253.394 538.3L226.334 538.3L226.334 539ZM253.394 539L252.694 539L252.694 562L253.394 562L254.094 562L254.094 539L253.394 539ZM253.394 562L253.394 562.7L268.034 562.7L268.034 562L268.034 561.3L253.394 561.3L253.394 562Z"
            fill="black"
          />
          <path
            id="Vector_42"
            d="M839.334 323.928L839.334 324.628L838.634 324.628L838.634 323.928L839.334 323.928ZM928.334 323.928L928.334 323.228L929.034 323.228L929.034 323.928L928.334 323.928ZM928.334 346.219L929.034 346.219L929.034 346.919L928.334 346.919L928.334 346.219ZM839.334 346.219L838.634 346.219L838.634 345.519L839.334 345.519L839.334 346.219ZM839.334 453L835.293 446L843.375 446L839.334 453ZM839.334 270L840.034 270L840.034 323.928L839.334 323.928L838.634 323.928L838.634 270L839.334 270ZM839.334 323.928L839.334 323.228L928.334 323.228L928.334 323.928L928.334 324.628L839.334 324.628L839.334 323.928ZM928.334 323.928L929.034 323.928L929.034 346.219L928.334 346.219L927.634 346.219L927.634 323.928L928.334 323.928ZM928.334 346.219L928.334 346.919L839.334 346.919L839.334 346.219L839.334 345.519L928.334 345.519L928.334 346.219ZM839.334 346.219L840.034 346.219L840.034 446.7L839.334 446.7L838.634 446.7L838.634 346.219L839.334 346.219Z"
            fill="black"
          />
          <path
            id="Vector_43"
            d="M829.334 323.883L829.334 324.583L830.034 324.583L830.034 323.883L829.334 323.883ZM738.334 323.883L738.334 323.183L737.634 323.183L737.634 323.883L738.334 323.883ZM738.334 346.162L737.634 346.162L737.634 346.862L738.334 346.862L738.334 346.162ZM829.334 346.162L830.034 346.162L830.034 345.462L829.334 345.462L829.334 346.162ZM829.334 453L833.375 446L825.293 446L829.334 453ZM829.334 270L828.634 270L828.634 323.883L829.334 323.883L830.034 323.883L830.034 270L829.334 270ZM829.334 323.883L829.334 323.183L738.334 323.183L738.334 323.883L738.334 324.583L829.334 324.583L829.334 323.883ZM738.334 323.883L737.634 323.883L737.634 346.162L738.334 346.162L739.034 346.162L739.034 323.883L738.334 323.883ZM738.334 346.162L738.334 346.862L829.334 346.862L829.334 346.162L829.334 345.462L738.334 345.462L738.334 346.162ZM829.334 346.162L828.634 346.162L828.634 446.7L829.334 446.7L830.034 446.7L830.034 346.162L829.334 346.162Z"
            fill="black"
          />
          <g id="Report titles">
            <text
              fontFamily="Gilroy W05 Medium"
              fontSize={16}
              letterSpacing="0em"
              id="25-Hydroxy Vitamin D"
              fill="#282828"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
            >
              <tspan x={32} y={261.448}>
                Entry from diet
              </tspan>
            </text>
          </g>
          <g id="Report titles_2">
            <text
              fontFamily="Gilroy W05 Medium"
              fontSize={16}
              letterSpacing="0em"
              id="25-Hydroxy Vitamin D_2"
              fill="#282828"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
            >
              <tspan x={950} y={256.448}>
                Fasting
              </tspan>
            </text>
          </g>
          <path
            id="Vector_44"
            d="M314.334 1427L321.334 1431.04L321.334 1422.96L314.334 1427ZM446.334 1427L446.334 1426.3L320.634 1426.3L320.634 1427L320.634 1427.7L446.334 1427.7L446.334 1427Z"
            fill="black"
          />
          <g id="Group 627">
            <path
              id="Vector_45"
              d="M344.636 1460.34L344.734 1457.13L347.46 1458.82L344.636 1460.34ZM375.388 1427.53L375.459 1427.8C371.392 1428.87 366.931 1431.94 362.048 1437.04C357.169 1442.14 351.89 1449.25 346.186 1458.36L345.951 1458.21L345.715 1458.07C351.43 1448.93 356.731 1441.79 361.646 1436.66C366.558 1431.52 371.106 1428.37 375.317 1427.26L375.388 1427.53Z"
              fill="black"
            />
          </g>
          <rect id="Rectangle 473" x={575} y={1204} width={110} height={123} stroke="black" />
          <rect
            id="Rectangle 474"
            x={261.334}
            y={1416}
            width={42}
            height={27}
            stroke="#FFCCCA"
            strokeWidth={1.4}
            strokeDasharray="2 2"
          />
          <path
            id="Rectangle 471"
            d="M478.334 780H791.334V835H478.334V780Z"
            stroke="#FFCCCA"
            strokeWidth={1.4}
            strokeDasharray="4 4"
          />
          <path
            id="Rectangle 472"
            opacity={0.4}
            d="M478.334 771.693L791.334 772V668H650.777V724.208H478.334V771.693Z"
            stroke="#FFCCCA"
            strokeWidth={1.4}
            strokeDasharray="2.8 2.8"
          />
          <path
            id="Vector_46"
            d="M575 1215L568 1210.96V1219.04L575 1215ZM528 1215V1214.3H527.3V1215H528ZM528 1215V1215.7H568.7V1215V1214.3H528V1215ZM528 1215H527.3V1224H528H528.7V1215H528Z"
            fill="black"
          />
          <path
            id="Vector 359"
            d="M363.499 985.5L364.441 977.472L357.018 980.67L363.499 985.5ZM442.429 933V933.7C449.174 933.7 454.747 934.45 458.93 935.739C463.14 937.037 465.823 938.842 466.973 940.854C468.073 942.779 467.866 945.081 465.813 947.713C463.739 950.373 459.838 953.272 453.789 956.188L454.093 956.819L454.397 957.45C460.526 954.495 464.651 951.481 466.917 948.574C469.205 945.64 469.653 942.721 468.188 940.159C466.773 937.684 463.671 935.736 459.342 934.402C454.986 933.059 449.265 932.3 442.429 932.3V933ZM454.093 956.819L453.789 956.188C441.739 961.998 429.248 963.661 416.76 963.862C410.515 963.963 404.281 963.698 398.104 963.407C391.934 963.116 385.817 962.798 379.837 962.798V963.498V964.198C385.776 964.198 391.855 964.514 398.038 964.805C404.214 965.096 410.488 965.363 416.783 965.262C429.375 965.059 442.093 963.382 454.397 957.45L454.093 956.819ZM379.837 963.498V962.798C370.599 962.798 365.18 965.064 362.337 968.445C359.486 971.835 359.382 976.156 360.328 979.887L361.007 979.715L361.685 979.543C360.799 976.045 360.961 972.257 363.409 969.346C365.864 966.426 370.777 964.198 379.837 964.198V963.498Z"
            fill="black"
          />
          <g id="lines_2">
            <path
              id="Vector_47"
              d="M23.5 287.5L996.5 287.5"
              stroke="#818181"
              strokeLinecap="round"
              strokeDasharray="8 8"
            />
            <g id="Frame 469">
              <text
                fontFamily="Gilroy W05 Regular"
                fontSize={14}
                letterSpacing="0em"
                id="Section Divider SubLabel"
                transform="translate(23 288)"
                fill="#818181"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
              >
                <tspan x={0} y={16.76}>
                  Adipose Tissue
                </tspan>
              </text>
            </g>
          </g>
          <g id="lines_3">
            <path
              id="Vector_48"
              d="M23.5 656.5L996.5 656.5"
              stroke="#818181"
              strokeLinecap="round"
              strokeDasharray="8 8"
            />
            <g id="Frame 469_2">
              <text
                fontFamily="Gilroy W05 Regular"
                fontSize={14}
                letterSpacing="0em"
                id="Section Divider SubLabel_2"
                transform="translate(23 657)"
                fill="#818181"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
              >
                <tspan x={0} y={16.76}>
                  Arterial wall
                </tspan>
              </text>
            </g>
          </g>
          <g id="lines_4">
            <path
              id="Vector_49"
              d="M23.5 850.5L996.5 850.5"
              stroke="#818181"
              strokeLinecap="round"
              strokeDasharray="8 8"
            />
            <g id="Frame 469_3">
              <text
                fontFamily="Gilroy W05 Regular"
                fontSize={14}
                letterSpacing="0em"
                id="Section Divider SubLabel_3"
                transform="translate(23 851)"
                fill="#818181"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
              >
                <tspan x={0} y={16.76}>
                  Blood
                </tspan>
              </text>
            </g>
          </g>
          <g id="lines_5">
            <path
              id="Vector_50"
              d="M23.5 1195.5L996.5 1195.5"
              stroke="#818181"
              strokeLinecap="round"
              strokeDasharray="8 8"
            />
            <g id="Frame 469_4">
              <text
                fontFamily="Gilroy W05 Regular"
                fontSize={14}
                letterSpacing="0em"
                id="Section Divider SubLabel_4"
                transform="translate(23 1196)"
                fill="#818181"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
              >
                <tspan x={0} y={16.76}>
                  Liver
                </tspan>
              </text>
            </g>
          </g>
          <g id="lines_6">
            <path
              id="Vector_51"
              d="M23.5 1393.5L996.5 1393.5"
              stroke="#818181"
              strokeLinecap="round"
              strokeDasharray="8 8"
            />
            <g id="Frame 469_5">
              <text
                fontFamily="Gilroy W05 Regular"
                fontSize={14}
                letterSpacing="0em"
                id="Section Divider SubLabel_5"
                transform="translate(23 1394)"
                fill="#818181"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
              >
                <tspan x={0} y={16.76}>
                  Mitochondria of liver & muscle cells
                </tspan>
              </text>
            </g>
          </g>
          <g id="lines_7">
            <path
              id="Vector_52"
              d="M152.7 255.342H152L152 256.742H152.7L152.7 256.042L152.7 255.342ZM280 256.042L273 252L273 260.083L280 256.042ZM152.7 256.042L152.7 256.742L273.7 256.742L273.7 256.042L273.7 255.342L152.7 255.342L152.7 256.042Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_8">
            <path
              id="Vector_53"
              d="M173.741 387.7L173.741 387L172.341 387L172.341 387.7L173.041 387.7L173.741 387.7ZM173.041 465L177.082 458L169 458L173.041 465ZM173.041 387.7L172.341 387.7L172.341 458.7L173.041 458.7L173.741 458.7L173.741 387.7L173.041 387.7Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_9">
            <path
              id="Vector_54"
              d="M173.741 486.7L173.741 486L172.341 486L172.341 486.7L173.041 486.7L173.741 486.7ZM173.041 535L177.082 528L169 528L173.041 535ZM173.041 486.7L172.341 486.7L172.341 528.7L173.041 528.7L173.741 528.7L173.741 486.7L173.041 486.7Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_10">
            <path
              id="Vector_55"
              d="M160.7 696.342H160L160 697.742H160.7L160.7 697.042L160.7 696.342ZM216 697.042L209 693L209 701.083L216 697.042ZM160.7 697.042L160.7 697.742H209.7L209.7 697.042L209.7 696.342H160.7L160.7 697.042Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_11">
            <path
              id="Vector_56"
              d="M293.7 696.342H293L293 697.742H293.7L293.7 697.042L293.7 696.342ZM349 697.042L342 693L342 701.083L349 697.042ZM293.7 697.042L293.7 697.742H342.7L342.7 697.042L342.7 696.342H293.7L293.7 697.042Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_12">
            <path
              id="Vector_57"
              d="M419.7 698.342H419L419 699.742H419.7L419.7 699.042L419.7 698.342ZM537 699.042L530 695L530 703.083L537 699.042ZM419.7 699.042L419.7 699.742H530.7L530.7 699.042L530.7 698.342H419.7L419.7 699.042Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_13">
            <path
              id="Vector_58"
              d="M587.7 697.342H587L587 698.742H587.7L587.7 698.042L587.7 697.342ZM639 698.042L632 694L632 702.083L639 698.042ZM587.7 698.042L587.7 698.742H632.7L632.7 698.042L632.7 697.342H587.7L587.7 698.042Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_14">
            <path
              id="Vector_59"
              d="M595 747.042L602 751.083L602 743L595 747.042ZM659.3 747.742H660L660 746.342H659.3L659.3 747.042L659.3 747.742ZM601.3 747.042L601.3 747.742H659.3L659.3 747.042L659.3 746.342H601.3L601.3 747.042Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_15">
            <path
              id="Vector_60"
              d="M721.742 709.7L721.742 709L720.342 709L720.342 709.7L721.042 709.7L721.742 709.7ZM721.042 737L725.083 730L717.001 730L721.042 737ZM721.042 709.7L720.342 709.7L720.342 730.7L721.042 730.7L721.742 730.7L721.742 709.7L721.042 709.7Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_16">
            <path
              id="Vector_61"
              d="M432.659 494.7L432.659 494L431.259 494L431.259 494.7L431.959 494.7L432.659 494.7ZM431.959 590L436 583L427.918 583L431.959 590ZM431.959 494.7L431.259 494.7L431.259 583.7L431.959 583.7L432.659 583.7L432.659 494.7L431.959 494.7Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_17">
            <path
              id="Vector_62"
              d="M632.341 1352.3L632.341 1353L633.741 1353L633.741 1352.3L633.041 1352.3L632.341 1352.3ZM633.041 1327L629 1334L637.082 1334L633.041 1327ZM633.041 1352.3L633.741 1352.3L633.741 1333.3L633.041 1333.3L632.341 1333.3L632.341 1352.3L633.041 1352.3Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_18">
            <path
              id="Vector_63"
              d="M809.3 1221.66L810 1221.66L810 1220.26L809.3 1220.26L809.3 1220.96L809.3 1221.66ZM690 1220.96L697 1225L697 1216.92L690 1220.96ZM809.3 1220.96L809.3 1220.26L696.3 1220.26L696.3 1220.96L696.3 1221.66L809.3 1221.66L809.3 1220.96Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_19">
            <path
              id="Vector_64"
              d="M130.041 1229L134.082 1222L126 1222L130.041 1229ZM130.041 720L126 727L134.082 727L130.041 720ZM130.041 1222.7L130.741 1222.7L130.741 726.3L130.041 726.3L129.341 726.3L129.341 1222.7L130.041 1222.7Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_20">
            <path
              id="Vector_65"
              d="M835.659 503.7L835.659 503L834.259 503L834.259 503.7L834.959 503.7L835.659 503.7ZM834.959 562L839 555L830.918 555L834.959 562ZM834.959 503.7L834.259 503.7L834.259 555.7L834.959 555.7L835.659 555.7L835.659 503.7L834.959 503.7Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_21">
            <path
              id="Vector_66"
              d="M834.659 622.7L834.659 622L833.259 622L833.259 622.7L833.959 622.7L834.659 622.7ZM833.959 881L838 874L829.918 874L833.959 881ZM833.959 622.7L833.259 622.7L833.259 874.7L833.959 874.7L834.659 874.7L834.659 622.7L833.959 622.7Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_22">
            <path
              id="Vector_67"
              d="M432.659 406.7L432.659 406L431.259 406L431.259 406.7L431.959 406.7L432.659 406.7ZM431.959 433L436 426L427.918 426L431.959 433ZM431.959 406.7L431.259 406.7L431.259 426.7L431.959 426.7L432.659 426.7L432.659 406.7L431.959 406.7Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_23">
            <path
              id="Vector_68"
              d="M876 251.042L883 255.083L883 247L876 251.042ZM939.3 251.742H940L940 250.342H939.3L939.3 251.042L939.3 251.742ZM882.3 251.042L882.3 251.742L939.3 251.742L939.3 251.042L939.3 250.342L882.3 250.342L882.3 251.042Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="Report titles_3">
            <text
              fontFamily="Gilroy W05 Medium"
              fontSize={12}
              letterSpacing="0px"
              id="25-Hydroxy Vitamin D_3"
              fill="#1A1A1A"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
            >
              <tspan x={287.18} y={252.086}>
                Glucose-6-P{" "}
              </tspan>
              <tspan x={307.641} y={268.086}>
                (G6P)
              </tspan>
            </text>
          </g>
          <g id="Report titles_4">
            <text
              fontFamily="Gilroy W05 Medium"
              fontSize={12}
              letterSpacing="0px"
              id="25-Hydroxy Vitamin D_4"
              fill="#1A1A1A"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
            >
              <tspan x={124.291} y={347.086}>
                IRS1-bound Insulin
              </tspan>
            </text>
          </g>
          <g id="Report titles_5">
            <text
              fontFamily="Gilroy W05 Medium"
              fontSize={12}
              letterSpacing="0px"
              id="25-Hydroxy Vitamin D_5"
              fill="#1A1A1A"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
            >
              <tspan x={141.084} y={479.086}>
                Adiponectin
              </tspan>
            </text>
          </g>
          <g id="Report titles_6">
            <text
              fontFamily="Gilroy W05 Medium"
              fontSize={12}
              letterSpacing="0px"
              id="25-Hydroxy Vitamin D_6"
              fill="#1A1A1A"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
            >
              <tspan x={218.404} y={701.086}>
                Macrophage
              </tspan>
            </text>
          </g>
          <g id="Report titles_7">
            <text
              fontFamily="Gilroy W05 Medium"
              fontSize={12}
              letterSpacing="0px"
              id="25-Hydroxy Vitamin D_7"
              fill="#1A1A1A"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
            >
              <tspan x={360.039} y={703.086}>
                Foam cell
              </tspan>
            </text>
          </g>
          <g id="Report titles_8">
            <text
              fontFamily="Gilroy W05 Medium"
              fontSize={12}
              letterSpacing="0px"
              id="25-Hydroxy Vitamin D_8"
              fill="#1A1A1A"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
            >
              <tspan x={302.16} y={800.086}>
                IL6 +{" "}
              </tspan>
              <tspan x={304.1} y={816.086}>
                TNF
              </tspan>
            </text>
          </g>
          <g id="Report titles_9">
            <text
              fontFamily="Gilroy W05 Medium"
              fontSize={12}
              letterSpacing="0px"
              id="25-Hydroxy Vitamin D_9"
              fill="#1A1A1A"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
            >
              <tspan x={365.33} y={806.086}>
                IRS1
              </tspan>
            </text>
          </g>
          <g id="Report titles_10">
            <text
              fontFamily="Gilroy W05 Medium"
              fontSize={12}
              letterSpacing="0px"
              id="25-Hydroxy Vitamin D_10"
              fill="#1A1A1A"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
            >
              <tspan x={547.115} y={694.086}>
                Fatty{" "}
              </tspan>
              <tspan x={543.465} y={710.086}>
                streaks
              </tspan>
            </text>
          </g>
          <g id="Report titles_11">
            <text
              fontFamily="Gilroy W05 Medium"
              fontSize={10}
              letterSpacing="0px"
              id="25-Hydroxy Vitamin D_11"
              fill="#1A1A1A"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
            >
              <tspan x={685.184} y={686.405}>
                Atherosclerotic{" "}
              </tspan>
              <tspan x={700.979} y={702.405}>
                plaques
              </tspan>
            </text>
          </g>
          <g id="Report titles_12">
            <text
              fontFamily="Gilroy W05 Medium"
              fontSize={10}
              letterSpacing="0px"
              id="25-Hydroxy Vitamin D_12"
              fill="#1A1A1A"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
            >
              <tspan x={667.056} y={751.405}>
                Narrowing of arteries
              </tspan>
            </text>
          </g>
          <g id="Report titles_13">
            <text
              fontFamily="Gilroy W05 Medium"
              fontSize={10}
              letterSpacing="0px"
              id="25-Hydroxy Vitamin D_13"
              fill="#1A1A1A"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
            >
              <tspan x={506.156} y={744.405}>
                Cardiovascular{" "}
              </tspan>
              <tspan x={523.314} y={760.405}>
                disease
              </tspan>
            </text>
          </g>
          <g id="Report titles_14">
            <text
              fontFamily="Gilroy W05 Medium"
              fontSize={10}
              letterSpacing="0px"
              id="25-Hydroxy Vitamin D_14"
              fill="#1A1A1A"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
            >
              <tspan x={511.354} y={801.405}>
                Insulin{" "}
              </tspan>
              <tspan x={502.282} y={817.405}>
                resistance
              </tspan>
            </text>
          </g>
          <g id="Report titles_15">
            <text
              fontFamily="Gilroy W05 Medium"
              fontSize={10}
              letterSpacing="0px"
              id="25-Hydroxy Vitamin D_15"
              fill="#1A1A1A"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
            >
              <tspan x={634.079} y={793.405}>
                Type 2 diabetes
              </tspan>
            </text>
          </g>
          <g id="Report titles_16">
            <text
              fontFamily="Gilroy W05 Medium"
              fontSize={10}
              letterSpacing="0px"
              id="25-Hydroxy Vitamin D_16"
              fill="#1A1A1A"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
            >
              <tspan x={635.477} y={810.405}>
                Metabolic syndrome
              </tspan>
            </text>
          </g>
          <g id="Report titles_17">
            <text
              fontFamily="Gilroy W05 Medium"
              fontSize={10}
              letterSpacing="0px"
              id="25-Hydroxy Vitamin D_17"
              fill="#1A1A1A"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
            >
              <tspan x={634.475} y={828.405}>
                Endothellal dysfunction
              </tspan>
            </text>
          </g>
          <g id="Report titles_18">
            <text
              fontFamily="Gilroy W05 Medium"
              fontSize={10}
              letterSpacing="0px"
              id="25-Hydroxy Vitamin D_18"
              fill="#1A1A1A"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
            >
              <tspan x={147.94} y={549.405}>
                Adipocyte{" "}
              </tspan>
              <tspan x={117.271} y={565.405}>
                (cells that can store fat)
              </tspan>
            </text>
          </g>
          <g id="Report titles_19">
            <text
              fontFamily="Gilroy W05 Medium"
              fontSize={10}
              letterSpacing="0px"
              id="25-Hydroxy Vitamin D_19"
              fill="#1A1A1A"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
            >
              <tspan x={283.385} y={514.405}>
                Improved insulin sensitivity
              </tspan>
            </text>
          </g>
          <g id="Report titles_20">
            <text
              fontFamily="Gilroy W05 Medium"
              fontSize={10}
              letterSpacing="0px"
              id="25-Hydroxy Vitamin D_20"
              fill="#1A1A1A"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
            >
              <tspan x={264.109} y={607.405}>
                Packed into lipid droplets{" "}
              </tspan>
              <tspan x={293.719} y={623.405}>
                (fat storage)
              </tspan>
            </text>
          </g>
          <g id="Report titles_21">
            <text
              fontFamily="Gilroy W05 Medium"
              fontSize={10}
              letterSpacing="0px"
              id="25-Hydroxy Vitamin D_21"
              fill="#818181"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
            >
              <tspan x={120.062} y={507.405}>
                Formation
              </tspan>
            </text>
          </g>
          <g id="Report titles_22">
            <text
              fontFamily="Gilroy W05 Medium"
              fontSize={10}
              letterSpacing="0px"
              id="25-Hydroxy Vitamin D_22"
              fill="#818181"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
            >
              <tspan x={169.481} y={690.405}>
                Uptake
              </tspan>
            </text>
          </g>
          <g id="Report titles_23">
            <text
              fontFamily="Gilroy W05 Medium"
              fontSize={10}
              letterSpacing="0px"
              id="25-Hydroxy Vitamin D_23"
              fill="#818181"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
            >
              <tspan x={445.462} y={690.405}>
                Accumulation
              </tspan>
            </text>
          </g>
          <g id="Report titles_24">
            <text
              fontFamily="Gilroy W05 Medium"
              fontSize={10}
              letterSpacing="0px"
              id="25-Hydroxy Vitamin D_24"
              fill="#818181"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
            >
              <tspan x={404.261} y={793.405}>
                Damage
              </tspan>
            </text>
          </g>
          <g id="Report titles_25">
            <rect width={52} height={20} transform="translate(399 950)" fill="white" />
            <text
              fontFamily="Gilroy W05 Medium"
              fontSize={10}
              letterSpacing="0px"
              id="25-Hydroxy Vitamin D_25"
              fill="#818181"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
            >
              <tspan x={399.302} y={963.405}>
                Transferred
              </tspan>
            </text>
          </g>
          <g id="Report titles_26">
            <rect width={104} height={36} transform="translate(189 993)" fill="white" />
            <text
              fontFamily="Gilroy W05 Medium"
              fontSize={10}
              letterSpacing="0px"
              id="25-Hydroxy Vitamin D_26"
              fill="#818181"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
            >
              <tspan x={189.047} y={1006.4}>
                Protein that hydrolyses{" "}
              </tspan>
              <tspan x={214.809} y={1022.4}>
                inside VLDL
              </tspan>
            </text>
          </g>
          <g id="Report titles_27">
            <rect width={57} height={20} transform="translate(217 1040)" fill="white" />
            <text
              fontFamily="Gilroy W05 Medium"
              fontSize={10}
              letterSpacing="0px"
              id="25-Hydroxy Vitamin D_27"
              fill="#818181"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
            >
              <tspan x={217.404} y={1053.4}>
                VLDL shrinks
              </tspan>
            </text>
          </g>
          <g id="Report titles_28">
            <rect width={70} height={20} transform="translate(171 1123)" fill="white" />
            <text
              fontFamily="Gilroy W05 Medium"
              fontSize={10}
              letterSpacing="0px"
              id="25-Hydroxy Vitamin D_28"
              fill="#818181"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
            >
              <tspan x={171.425} y={1136.4}>
                Hepatic Lipase
              </tspan>
            </text>
          </g>
          <g id="Report titles_29">
            <rect width={59} height={20} transform="translate(256 1123)" fill="white" />
            <text
              fontFamily="Gilroy W05 Medium"
              fontSize={10}
              letterSpacing="0px"
              id="25-Hydroxy Vitamin D_29"
              fill="#818181"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
            >
              <tspan x={256.154} y={1136.4}>
                Back to Liver
              </tspan>
            </text>
          </g>
          <g id="Report titles_30">
            <rect width={73} height={20} transform="translate(366 1086)" fill="white" />
            <text
              fontFamily="Gilroy W05 Medium"
              fontSize={10}
              letterSpacing="0px"
              id="25-Hydroxy Vitamin D_30"
              fill="#818181"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
            >
              <tspan x={366.294} y={1099.4}>
                Indirect booster
              </tspan>
            </text>
          </g>
          <g id="Report titles_31">
            <rect width={46} height={20} transform="translate(136 1058)" fill="white" />
            <text
              fontFamily="Gilroy W05 Medium"
              fontSize={10}
              letterSpacing="0px"
              id="25-Hydroxy Vitamin D_31"
              fill="#1A1A1A"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
            >
              <tspan x={136.29} y={1071.4}>
                + Glycerol
              </tspan>
            </text>
          </g>
          <g id="Report titles_32">
            <rect width={73} height={36} transform="translate(275 1305)" fill="white" />
            <text
              fontFamily="Gilroy W05 Medium"
              fontSize={12}
              letterSpacing="0px"
              id="25-Hydroxy Vitamin D_32"
              fill="#1A1A1A"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
            >
              <tspan x={275.418} y={1319.09}>
                Cleared from{" "}
              </tspan>
              <tspan x={282.754} y={1335.09}>
                circulation
              </tspan>
            </text>
          </g>
          <g id="Report titles_33">
            <rect width={143} height={20} transform="translate(444 1414)" fill="white" />
            <text
              fontFamily="Gilroy W05 Medium"
              fontSize={12}
              letterSpacing="0px"
              id="25-Hydroxy Vitamin D_33"
              fill="#1A1A1A"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
            >
              <tspan x={444.08} y={1428.09}>
                FFA oxidation/breakdown
              </tspan>
            </text>
          </g>
          <g id="Report titles_34">
            <rect width={258} height={52} transform="translate(321 1465)" fill="white" />
            <text
              fontFamily="Gilroy W05 Medium"
              fontSize={10}
              letterSpacing="0px"
              id="25-Hydroxy Vitamin D_34"
              fill="#1A1A1A"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
            >
              <tspan x={321} y={1478.4}>
                Acetyl-CoA{" "}
              </tspan>
              <tspan x={336} y={1494.4}>
                Enter TCA{" "}
              </tspan>
              <tspan x={336} y={1510.4}>
                Converts to ketone bodies (during prolonged fasting)
              </tspan>
            </text>
          </g>
          <g id="Report titles_35">
            <rect width={77} height={20} transform="translate(716 1198)" fill="white" />
            <text
              fontFamily="Gilroy W05 Medium"
              fontSize={10}
              letterSpacing="0px"
              id="25-Hydroxy Vitamin D_35"
              fill="#818181"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
            >
              <tspan x={716.292} y={1211.4}>
                Re-esterification
              </tspan>
            </text>
          </g>
          <g id="Report titles_36">
            <rect width={49} height={20} transform="translate(837 1071)" fill="white" />
            <text
              fontFamily="Gilroy W05 Medium"
              fontSize={10}
              letterSpacing="0px"
              id="25-Hydroxy Vitamin D_36"
              fill="#818181"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
            >
              <tspan x={837.447} y={1084.4}>
                Transports
              </tspan>
            </text>
          </g>
          <g id="Report titles_37">
            <rect width={113} height={20} transform="translate(698 1226)" fill="white" />
            <text
              fontFamily="Gilroy W05 Medium"
              fontSize={10}
              letterSpacing="0px"
              id="25-Hydroxy Vitamin D_37"
              fill="#818181"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
            >
              <tspan x={698.45} y={1239.4}>
                {" "}
                + glycerol-3-phosphate
              </tspan>
            </text>
          </g>
          <g id="Report titles_38">
            <rect width={98} height={20} transform="translate(665 1399)" fill="white" />
            <text
              fontFamily="Gilroy W05 Medium"
              fontSize={10}
              letterSpacing="0px"
              id="25-Hydroxy Vitamin D_38"
              fill="#818181"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
            >
              <tspan x={665.304} y={1412.4}>
                Activates gene for FA
              </tspan>
            </text>
          </g>
          <g id="Report titles_39">
            <rect width={86} height={20} transform="translate(671 1427)" fill="white" />
            <text
              fontFamily="Gilroy W05 Medium"
              fontSize={10}
              letterSpacing="0px"
              id="25-Hydroxy Vitamin D_39"
              fill="#818181"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
            >
              <tspan x={671.124} y={1440.4}>
                oxidation enzymes
              </tspan>
            </text>
          </g>
          <g id="Report titles_40">
            <rect width={76} height={20} transform="translate(484 1432)" fill="white" />
            <text
              fontFamily="Gilroy W05 Medium"
              fontSize={10}
              letterSpacing="0px"
              id="25-Hydroxy Vitamin D_40"
              fill="#818181"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
            >
              <tspan x={484.144} y={1445.4}>
                (Beta-oxidation)
              </tspan>
            </text>
          </g>
          <g id="Report titles_41">
            <rect width={85} height={20} transform="translate(344 1403)" fill="white" />
            <text
              fontFamily="Gilroy W05 Medium"
              fontSize={10}
              letterSpacing="0px"
              id="25-Hydroxy Vitamin D_41"
              fill="#818181"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
            >
              <tspan x={344.425} y={1416.4}>
                Energy production
              </tspan>
            </text>
          </g>
          <g id="Report titles_42">
            <rect width={45} height={20} transform="translate(458 1366)" fill="white" />
            <text
              fontFamily="Gilroy W05 Medium"
              fontSize={10}
              letterSpacing="0px"
              id="25-Hydroxy Vitamin D_42"
              fill="#FFC647"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
            >
              <tspan x={458.415} y={1379.4}>
                Enhances
              </tspan>
            </text>
          </g>
          <g id="Report titles_43">
            <rect width={33} height={20} transform="translate(206 963)" fill="white" />
            <text
              fontFamily="Gilroy W05 Medium"
              fontSize={10}
              letterSpacing="0px"
              id="25-Hydroxy Vitamin D_43"
              fill="#FFC647"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
            >
              <tspan x={206.489} y={976.405}>
                reduce
              </tspan>
            </text>
          </g>
          <g id="Report titles_44">
            <rect width={59} height={20} transform="translate(195 938)" fill="white" />
            <text
              fontFamily="Gilroy W05 Medium"
              fontSize={10}
              letterSpacing="0px"
              id="25-Hydroxy Vitamin D_44"
              fill="#FFC647"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
            >
              <tspan x={195.169} y={951.405}>
                Free radicals
              </tspan>
            </text>
          </g>
          <g id="Report titles_45">
            <rect width={7} height={20} transform="translate(634 1260)" fill="white" />
            <text
              fontFamily="Gilroy W05 Medium"
              fontSize={12}
              letterSpacing="0px"
              id="25-Hydroxy Vitamin D_45"
              fill="#1A1A1A"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
            >
              <tspan x={634.23} y={1274.09}>
                +
              </tspan>
            </text>
          </g>
          <g id="Report titles_46">
            <text
              fontFamily="Gilroy W05 Medium"
              fontSize={10}
              letterSpacing="0px"
              id="25-Hydroxy Vitamin D_46"
              fill="#818181"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
            >
              <tspan x={203.351} y={770.405}>
                Release
              </tspan>
            </text>
          </g>
          <g id="Report titles_47">
            <text
              fontFamily="Gilroy W05 Medium"
              fontSize={10}
              letterSpacing="0px"
              id="25-Hydroxy Vitamin D_47"
              fill="#818181"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
            >
              <tspan x={461.353} y={562.405}>
                Coats & protects fat (TG) from{" "}
              </tspan>
              <tspan x={480.234} y={578.405}>
                breakdown by lipases
              </tspan>
            </text>
          </g>
          <g id="Report titles_48">
            <text
              fontFamily="Gilroy W05 Medium"
              fontSize={10}
              letterSpacing="0px"
              id="25-Hydroxy Vitamin D_48"
              fill="#818181"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
            >
              <tspan x={846.987} y={524.405}>
                Lipase access coated PLIN1{" "}
              </tspan>
              <tspan x={848.32} y={540.405}>
                droplets & breaks down TG
              </tspan>
            </text>
          </g>
          <g id="Report titles_49">
            <text
              fontFamily="Gilroy W05 Medium"
              fontSize={12}
              letterSpacing="0px"
              id="25-Hydroxy Vitamin D_49"
              fill="#1A1A1A"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
            >
              <tspan x={808.408} y={245.086}>
                Adrenalin{" "}
              </tspan>
              <tspan x={809.281} y={261.086}>
                secretion
              </tspan>
            </text>
          </g>
          <g id="Report titles_50">
            <text
              fontFamily="Gilroy W05 Medium"
              fontSize={10}
              letterSpacing="0px"
              id="25-Hydroxy Vitamin D_50"
              fill="#818181"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
            >
              <tspan x={760.484} y={316.405}>
                Stimulator
              </tspan>
            </text>
          </g>
          <g id="Report titles_51">
            <text
              fontFamily="Gilroy W05 Medium"
              fontSize={10}
              letterSpacing="0px"
              id="25-Hydroxy Vitamin D_51"
              fill="#818181"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
            >
              <tspan x={864.484} y={313.405}>
                Stimulator
              </tspan>
            </text>
          </g>
          <g id="Report titles_52">
            <text
              fontFamily="Gilroy W05 Medium"
              fontSize={10}
              letterSpacing="0px"
              id="25-Hydroxy Vitamin D_52"
              fill="#818181"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
            >
              <tspan x={784.123} y={406.405}>
                Lipolysis
              </tspan>
            </text>
          </g>
          <g id="gene-IRS1" {...geneGroupProps("IRS1", onGeneClick)}>
            <g id="gene-lozenge_5">
              <path
                d="M216 301C216 298.791 217.791 297 220 297H292C294.209 297 296 298.791 296 301V317C296 319.209 294.209 321 292 321H220C217.791 321 216 319.209 216 317V301Z"
                fill={irs1.lozengeFill}
              />
              <text
                fontFamily="Gilroy W05 Medium"
                fontSize={14}
                letterSpacing="0em"
                id="gene-label_5"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
              >
                <tspan x={243.552} y={313.767}>
                  IRS1
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="irs1"
              groupId="gene-snps"
              genePalette={irs1}
              startX={224}
              startY={323}
              snpCount={getGeneSnpCount("IRS1", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-PPARG" {...geneGroupProps("PPARG", onGeneClick)}>
            <g id="gene-lozenge_6">
              <path
                d="M136 374C136 371.791 137.791 370 140 370H212C214.209 370 216 371.791 216 374V390C216 392.209 214.209 394 212 394H140C137.791 394 136 392.209 136 390V374Z"
                fill={pparg.lozengeFill}
              />
              <text
                fontFamily="Gilroy W05 Medium"
                fontSize={14}
                letterSpacing="0em"
                id="gene-label_6"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
              >
                <tspan x={153.968} y={386.767}>
                  PPARG
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="pparg"
              groupId="gene-snps_2"
              genePalette={pparg}
              startX={144}
              startY={396}
              snpCount={getGeneSnpCount("PPARG", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-ADIPOQ" {...geneGroupProps("ADIPOQ", onGeneClick)}>
            <g id="gene-lozenge_7">
              <path
                d="M133 416C133 413.791 134.791 412 137 412H215C217.209 412 219 413.791 219 416V432C219 434.209 217.209 436 215 436H137C134.791 436 133 434.209 133 432V416Z"
                fill={adipoq.lozengeFill}
              />
              <text
                fontFamily="Gilroy W05 Medium"
                fontSize={14}
                letterSpacing="0em"
                id="gene-label_7"
                fill="black"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
              >
                <tspan x={149.449} y={428.767}>
                  ADIPOQ
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="adipoq"
              groupId="gene-snps_3"
              genePalette={adipoq}
              startX={141}
              startY={438}
              snpCount={getGeneSnpCount("ADIPOQ", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-APOA2" {...geneGroupProps("APOA2", onGeneClick)}>
            <g id="gene-lozenge_8">
              <path
                d="M232 862C232 859.791 233.791 858 236 858H308C310.209 858 312 859.791 312 862V878C312 880.209 310.209 882 308 882H236C233.791 882 232 880.209 232 878V862Z"
                fill={apoa2.lozengeFill}
              />
              <text
                fontFamily="Gilroy W05 Medium"
                fontSize={14}
                letterSpacing="0em"
                id="gene-label_8"
                fill="black"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
              >
                <tspan x={249.797} y={874.767}>
                  APOA2
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="apoa2"
              groupId="gene-snps_4"
              genePalette={apoa2}
              startX={240}
              startY={884}
              snpCount={getGeneSnpCount("APOA2", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-PON1" {...geneGroupProps("PON1", onGeneClick)}>
            <g id="gene-lozenge_9">
              <path
                d="M234 902C234 899.791 235.791 898 238 898H310C312.209 898 314 899.791 314 902V918C314 920.209 312.209 922 310 922H238C235.791 922 234 920.209 234 918V902Z"
                fill={pon1.lozengeFill}
              />
              <text
                fontFamily="Gilroy W05 Medium"
                fontSize={14}
                letterSpacing="0em"
                id="gene-label_9"
                fill="black"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
              >
                <tspan x={257.067} y={914.767}>
                  PON1
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="pon1"
              groupId="gene-snps_5"
              genePalette={pon1}
              startX={242}
              startY={924}
              snpCount={getGeneSnpCount("PON1", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-PPARG_2" {...geneGroupProps("PPARG", onGeneClick)}>
            <g id="gene-lozenge_10">
              <path
                d="M139 901C139 898.791 140.791 897 143 897H215C217.209 897 219 898.791 219 901V917C219 919.209 217.209 921 215 921H143C140.791 921 139 919.209 139 917V901Z"
                fill={pparg.lozengeFill}
              />
              <text
                fontFamily="Gilroy W05 Medium"
                fontSize={14}
                letterSpacing="0em"
                id="gene-label_10"
                fill="black"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
              >
                <tspan x={156.968} y={913.767}>
                  PPARG
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="pparg-2"
              groupId="gene-snps_6"
              genePalette={pparg}
              startX={147}
              startY={923}
              snpCount={getGeneSnpCount("PPARG", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-APOC1" {...geneGroupProps("APOC1", onGeneClick)}>
            <g id="gene-lozenge_11">
              <path
                d="M544 907C544 904.791 545.791 903 548 903H620C622.209 903 624 904.791 624 907V923C624 925.209 622.209 927 620 927H548C545.791 927 544 925.209 544 923V907Z"
                fill={apoc1.lozengeFill}
              />
              <text
                fontFamily="Gilroy W05 Medium"
                fontSize={14}
                letterSpacing="0em"
                id="gene-label_11"
                fill="black"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
              >
                <tspan x={562.139} y={919.767}>
                  APOC1
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="apoc1"
              groupId="gene-snps_7"
              genePalette={apoc1}
              startX={552}
              startY={929}
              snpCount={getGeneSnpCount("APOC1", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-APOC2" {...geneGroupProps("APOC2", onGeneClick)}>
            <g id="gene-lozenge_12">
              <path
                d="M477 952C477 949.791 478.791 948 481 948H553C555.209 948 557 949.791 557 952V968C557 970.209 555.209 972 553 972H481C478.791 972 477 970.209 477 968V952Z"
                fill={apoc2.lozengeFill}
              />
              <text
                fontFamily="Gilroy W05 Medium"
                fontSize={14}
                letterSpacing="0em"
                id="gene-label_12"
                fill="black"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
              >
                <tspan x={494.011} y={964.767}>
                  APOC2
                </tspan>
              </text>
              <path
                d="M566.875 945.754V947.477L564.199 947.384L565.728 949.692L564.228 950.615L562.875 948.123L561.522 950.615L560.022 949.692L561.551 947.384L558.875 947.477L558.875 945.754L561.551 945.846L560.022 943.538L561.522 942.615L562.875 945.108L564.228 942.615L565.728 943.538L564.199 945.846L566.875 945.754Z"
                fill="black"
              />
            </g>
            <GeneSnpShapes
              id="apoc2"
              groupId="gene-snps_8"
              genePalette={apoc2}
              startX={485}
              startY={974}
              snpCount={getGeneSnpCount("APOC2", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-APOC3" {...geneGroupProps("APOC3", onGeneClick)}>
            <g id="gene-lozenge_13">
              <path
                d="M694 972C694 969.791 695.791 968 698 968H770C772.209 968 774 969.791 774 972V988C774 990.209 772.209 992 770 992H698C695.791 992 694 990.209 694 988V972Z"
                fill={apoc3.lozengeFill}
              />
              <text
                fontFamily="Gilroy W05 Medium"
                fontSize={14}
                letterSpacing="0em"
                id="gene-label_13"
                fill="black"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
              >
                <tspan x={710.908} y={984.767}>
                  APOC3
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="apoc3"
              groupId="gene-snps_9"
              genePalette={apoc3}
              startX={702}
              startY={994}
              snpCount={getGeneSnpCount("APOC3", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-APOA5" {...geneGroupProps("APOA5", onGeneClick)}>
            <g id="gene-lozenge_14">
              <path
                d="M682 1063C682 1060.79 683.791 1059 686 1059H758C760.209 1059 762 1060.79 762 1063V1079C762 1081.21 760.209 1083 758 1083H686C683.791 1083 682 1081.21 682 1079V1063Z"
                fill={apoa5.lozengeFill}
              />
              <text
                fontFamily="Gilroy W05 Medium"
                fontSize={14}
                letterSpacing="0em"
                id="gene-label_14"
                fill="black"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
              >
                <tspan x={699.688} y={1075.77}>
                  APOA5
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="apoa5"
              groupId="gene-snps_10"
              genePalette={apoa5}
              startX={690}
              startY={1085}
              snpCount={getGeneSnpCount("APOA5", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-CD36" {...geneGroupProps("CD36", onGeneClick)}>
            <g id="gene-lozenge_15">
              <path
                d="M797 974C797 971.791 798.791 970 801 970H873C875.209 970 877 971.791 877 974V990C877 992.209 875.209 994 873 994H801C798.791 994 797 992.209 797 990V974Z"
                fill={cd36.lozengeFill}
              />
              <text
                fontFamily="Gilroy W05 Medium"
                fontSize={14}
                letterSpacing="0em"
                id="gene-label_15"
                fill="black"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
              >
                <tspan x={819.445} y={986.767}>
                  CD36
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="cd36"
              groupId="gene-snps_11"
              genePalette={cd36}
              startX={805}
              startY={996}
              snpCount={getGeneSnpCount("CD36", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-APOE" {...geneGroupProps("APOE", onGeneClick)}>
            <g id="gene-lozenge_16">
              <path
                d="M488 1069C488 1066.79 489.791 1065 492 1065H564C566.209 1065 568 1066.79 568 1069V1085C568 1087.21 566.209 1089 564 1089H492C489.791 1089 488 1087.21 488 1085V1069Z"
                fill={apoe.lozengeFill}
              />
              <text
                fontFamily="Gilroy W05 Medium"
                fontSize={14}
                letterSpacing="0em"
                id="gene-label_16"
                fill="black"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
              >
                <tspan x={510.097} y={1081.77}>
                  APOE
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="apoe"
              groupId="gene-snps_12"
              genePalette={apoe}
              startX={496}
              startY={1091}
              snpCount={getGeneSnpCount("APOE", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-LPL" {...geneGroupProps("LPL", onGeneClick)}>
            <g id="gene-lozenge_17">
              <path
                d="M277 1091C277 1088.79 278.791 1087 281 1087H353C355.209 1087 357 1088.79 357 1091V1107C357 1109.21 355.209 1111 353 1111H281C278.791 1111 277 1109.21 277 1107V1091Z"
                fill={lpl.lozengeFill}
              />
              <text
                fontFamily="Gilroy W05 Medium"
                fontSize={14}
                letterSpacing="0em"
                id="gene-label_17"
                fill="black"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
              >
                <tspan x={306.035} y={1103.77}>
                  LPL
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="lpl"
              groupId="gene-snps_13"
              genePalette={lpl}
              startX={285}
              startY={1113}
              snpCount={getGeneSnpCount("LPL", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-APOE_2" {...geneGroupProps("APOE", onGeneClick)}>
            <g id="gene-lozenge_18">
              <path
                d="M269 1165C269 1162.79 270.791 1161 273 1161H345C347.209 1161 349 1162.79 349 1165V1181C349 1183.21 347.209 1185 345 1185H273C270.791 1185 269 1183.21 269 1181V1165Z"
                fill={apoe.lozengeFill}
              />
              <text
                fontFamily="Gilroy W05 Medium"
                fontSize={14}
                letterSpacing="0em"
                id="gene-label_18"
                fill="black"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
              >
                <tspan x={291.097} y={1177.77}>
                  APOE
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="apoe-2"
              groupId="gene-snps_14"
              genePalette={apoe}
              startX={277}
              startY={1187}
              snpCount={getGeneSnpCount("APOE", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-LDLR" {...geneGroupProps("LDLR", onGeneClick)}>
            <g id="gene-lozenge_19">
              <path
                d="M177 1318C177 1315.79 178.791 1314 181 1314H253C255.209 1314 257 1315.79 257 1318V1334C257 1336.21 255.209 1338 253 1338H181C178.791 1338 177 1336.21 177 1334V1318Z"
                fill={ldlr.lozengeFill}
              />
              <text
                fontFamily="Gilroy W05 Medium"
                fontSize={14}
                letterSpacing="0em"
                id="gene-label_19"
                fill="black"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
              >
                <tspan x={200.86} y={1330.77}>
                  LDLR
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="ldlr"
              groupId="gene-snps_15"
              genePalette={ldlr}
              startX={185}
              startY={1340}
              snpCount={getGeneSnpCount("LDLR", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-LPA" {...geneGroupProps("LPA", onGeneClick)}>
            <g id="gene-lozenge_20">
              <path
                d="M490 1305C490 1302.79 491.791 1301 494 1301H566C568.209 1301 570 1302.79 570 1305V1321C570 1323.21 568.209 1325 566 1325H494C491.791 1325 490 1323.21 490 1321V1305Z"
                fill={lpa.lozengeFill}
              />
              <text
                fontFamily="Gilroy W05 Medium"
                fontSize={14}
                letterSpacing="0em"
                id="gene-label_20"
                fill="black"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
              >
                <tspan x={518.454} y={1317.77}>
                  LPA
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="lpa"
              groupId="gene-snps_16"
              genePalette={lpa}
              startX={498}
              startY={1327}
              snpCount={getGeneSnpCount("LPA", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-APOB" {...geneGroupProps("APOB", onGeneClick)}>
            <g id="gene-lozenge_21">
              <path
                d="M594 1355C594 1352.79 595.791 1351 598 1351H670C672.209 1351 674 1352.79 674 1355V1371C674 1373.21 672.209 1375 670 1375H598C595.791 1375 594 1373.21 594 1371V1355Z"
                fill={apob.lozengeFill}
              />
              <text
                fontFamily="Gilroy W05 Medium"
                fontSize={14}
                letterSpacing="0em"
                id="gene-label_21"
                fill="black"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
              >
                <tspan x={615.502} y={1367.77}>
                  APOB
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="apob"
              groupId="gene-snps_17"
              genePalette={apob}
              startX={602}
              startY={1377}
              snpCount={getGeneSnpCount("APOB", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-PPARA" {...geneGroupProps("PPARA", onGeneClick)}>
            <g id="gene-lozenge_22">
              <path
                d="M793 1287C793 1284.79 794.791 1283 797 1283H869C871.209 1283 873 1284.79 873 1287V1303C873 1305.21 871.209 1307 869 1307H797C794.791 1307 793 1305.21 793 1303V1287Z"
                fill={ppara.lozengeFill}
              />
              <text
                fontFamily="Gilroy W05 Medium"
                fontSize={14}
                letterSpacing="0em"
                id="gene-label_22"
                fill="black"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
              >
                <tspan x={811.966} y={1299.77}>
                  PPARA
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="ppara"
              groupId="gene-snps_18"
              genePalette={ppara}
              startX={801}
              startY={1309}
              snpCount={getGeneSnpCount("PPARA", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-PLIN1" {...geneGroupProps("PLIN1", onGeneClick)}>
            <g id="gene-lozenge_23">
              <path
                d="M393 372C393 369.791 394.791 368 397 368H469C471.209 368 473 369.791 473 372V388C473 390.209 471.209 392 469 392H397C394.791 392 393 390.209 393 388V372Z"
                fill={plin1.lozengeFill}
              />
              <text
                fontFamily="Gilroy W05 Medium"
                fontSize={14}
                letterSpacing="0em"
                id="gene-label_23"
                fill="black"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
              >
                <tspan x={416.512} y={384.767}>
                  PLIN1
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="plin1"
              groupId="gene-snps_19"
              genePalette={plin1}
              startX={401}
              startY={394}
              snpCount={getGeneSnpCount("PLIN1", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-ADRB2" {...geneGroupProps("ADRB2", onGeneClick)}>
            <g id="gene-lozenge_24">
              <path
                d="M744 336C744 333.791 745.791 332 748 332H820C822.209 332 824 333.791 824 336V352C824 354.209 822.209 356 820 356H748C745.791 356 744 354.209 744 352V336Z"
                fill={adrb2.lozengeFill}
              />
              <text
                fontFamily="Gilroy W05 Medium"
                fontSize={14}
                letterSpacing="0em"
                id="gene-label_24"
                fill="black"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
              >
                <tspan x={762.398} y={348.767}>
                  ADRB2
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="adrb2"
              groupId="gene-snps_20"
              genePalette={adrb2}
              startX={752}
              startY={358}
              snpCount={getGeneSnpCount("ADRB2", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-ADRB3" {...geneGroupProps("ADRB3", onGeneClick)}>
            <g id="gene-lozenge_25">
              <path
                d="M844 336C844 333.791 845.791 332 848 332H920C922.209 332 924 333.791 924 336V352C924 354.209 922.209 356 920 356H848C845.791 356 844 354.209 844 352V336Z"
                fill={adrb3.lozengeFill}
              />
              <text
                fontFamily="Gilroy W05 Medium"
                fontSize={14}
                letterSpacing="0em"
                id="gene-label_25"
                fill="black"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
              >
                <tspan x={862.146} y={348.767}>
                  ADRB3
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="adrb3"
              groupId="gene-snps_21"
              genePalette={adrb3}
              startX={852}
              startY={358}
              snpCount={getGeneSnpCount("ADRB3", expectedSnps, geneColors)}
            />
          </g>
          <g id="Coat Protien_2">
            <g id="diamond_3">
              <text
                fontFamily="Gilroy W05 Medium"
                fontSize={10}
                letterSpacing="0em"
                id="label"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
              >
                <tspan x={828.56} y={485.405}>
                  TG
                </tspan>
              </text>
              <path
                id="Vector 352_3"
                d="M815.5 479.149L834.501 460L853.5 479.149L844 497L834.5 497L825 497L815.5 479.149Z"
                stroke="#1A1A1A"
              />
              <path
                id="Vector 353_2"
                d="M810 479.325L834.501 455L859 479.325L846.75 502L834.5 502L822.25 502L810 479.325Z"
                stroke="#1A1A1A"
              />
            </g>
          </g>
          <g id="Coat Protien_3">
            <g id="diamond_4">
              <text
                fontFamily="Gilroy W05 Medium"
                fontSize={10}
                letterSpacing="0em"
                id="label_2"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
              >
                <tspan x={620.56} y={464.405}>
                  TG
                </tspan>
              </text>
              <path
                id="Vector 352_4"
                d="M607.5 458.149L626.501 439L645.5 458.149L636 476L626.5 476L617 476L607.5 458.149Z"
                stroke="#1A1A1A"
              />
              <path
                id="Vector 353_3"
                d="M602 458.325L626.501 434L651 458.325L638.75 481L626.5 481L614.25 481L602 458.325Z"
                stroke="#1A1A1A"
              />
            </g>
          </g>
          <g id="Lipids_3">
            <g id="diamond_5">
              <path
                id="Vector 352_5"
                d="M809 595.325L833.501 571L858 595.325L845.75 618L833.5 618L821.25 618L809 595.325Z"
                fill="white"
                stroke="#1A1A1A"
              />
              <text
                fontFamily="Gilroy W05 Medium"
                fontSize={10}
                letterSpacing="0em"
                id="label_3"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
              >
                <tspan x={825.787} y={601.405}>
                  FFA
                </tspan>
              </text>
            </g>
          </g>
          <g id="Lipids_4">
            <g id="diamond_6">
              <path
                id="Vector 352_6"
                d="M808 908.325L832.501 884L857 908.325L844.75 931L832.5 931L820.25 931L808 908.325Z"
                fill="white"
                stroke="#1A1A1A"
              />
              <text
                fontFamily="Gilroy W05 Bold"
                fontSize={10}
                letterSpacing="0em"
                id="label_4"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
              >
                <tspan x={824.631} y={914.415}>
                  FFA
                </tspan>
              </text>
            </g>
          </g>
          <g id="Coat Protien_4">
            <g id="diamond_7">
              <path
                id="Vector 352_7"
                d="M412.5 460.149L431.501 441L450.5 460.149L441 478L431.5 478L422 478L412.5 460.149Z"
                stroke="#1A1A1A"
              />
              <path
                id="Vector 353_4"
                d="M407 460.325L431.501 436L456 460.325L443.75 483L431.5 483L419.25 483L407 460.325Z"
                stroke="#1A1A1A"
              />
            </g>
          </g>
          <g id="Lipids_5">
            <g id="diamond_8">
              <path
                id="Vector 352_8"
                d="M297 566.325L321.501 542L346 566.325L333.75 589L321.5 589L309.25 589L297 566.325Z"
                fill="white"
                stroke="#1A1A1A"
              />
              <text
                fontFamily="Gilroy W05 Medium"
                fontSize={10}
                letterSpacing="0em"
                id="label_5"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
              >
                <tspan x={315.56} y={572.405}>
                  TG
                </tspan>
              </text>
            </g>
          </g>
          <g id="Lipids_6">
            <g id="diamond_9">
              <path
                id="Vector 352_9"
                d="M105 696.325L129.501 672L154 696.325L141.75 719L129.5 719L117.25 719L105 696.325Z"
                fill="white"
                stroke="#1A1A1A"
              />
              <text
                fontFamily="Gilroy W05 Bold"
                fontSize={10}
                letterSpacing="0em"
                id="label_6"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
              >
                <tspan x={120.82} y={697.415}>
                  oxi-{" "}
                </tspan>
                <tspan x={121.602} y={707.415}>
                  LDL
                </tspan>
              </text>
            </g>
          </g>
          <g id="Apolipoprotein_3">
            <path
              d="M338 880.5H376C381.799 880.5 386.5 885.201 386.5 891C386.5 896.799 381.799 901.5 376 901.5H338C332.201 901.5 327.5 896.799 327.5 891C327.5 885.201 332.201 880.5 338 880.5Z"
              fill="white"
            />
            <path
              d="M338 880.5H376C381.799 880.5 386.5 885.201 386.5 891C386.5 896.799 381.799 901.5 376 901.5H338C332.201 901.5 327.5 896.799 327.5 891C327.5 885.201 332.201 880.5 338 880.5Z"
              stroke="#1A1A1A"
            />
            <text
              fontFamily="Gilroy W05 Bold"
              fontSize={8}
              letterSpacing="2.8px"
              id="gene-label_26"
              fill="black"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
            >
              <tspan x={338.525} y={893.6}>
                APOA2
              </tspan>
            </text>
          </g>
          <g id="Apolipoprotein_4">
            <path
              d="M406 880.5H444C449.799 880.5 454.5 885.201 454.5 891C454.5 896.799 449.799 901.5 444 901.5H406C400.201 901.5 395.5 896.799 395.5 891C395.5 885.201 400.201 880.5 406 880.5Z"
              fill="white"
            />
            <path
              d="M406 880.5H444C449.799 880.5 454.5 885.201 454.5 891C454.5 896.799 449.799 901.5 444 901.5H406C400.201 901.5 395.5 896.799 395.5 891C395.5 885.201 400.201 880.5 406 880.5Z"
              stroke="#1A1A1A"
            />
            <text
              fontFamily="Gilroy W05 Bold"
              fontSize={8}
              letterSpacing="2.8px"
              id="gene-label_27"
              fill="black"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
            >
              <tspan x={406.771} y={893.6}>
                APOC1
              </tspan>
            </text>
          </g>
          <g id="Apolipoprotein_5">
            <path
              d="M406 921.5H444C449.799 921.5 454.5 926.201 454.5 932C454.5 937.799 449.799 942.5 444 942.5H406C400.201 942.5 395.5 937.799 395.5 932C395.5 926.201 400.201 921.5 406 921.5Z"
              fill="white"
            />
            <path
              d="M406 921.5H444C449.799 921.5 454.5 926.201 454.5 932C454.5 937.799 449.799 942.5 444 942.5H406C400.201 942.5 395.5 937.799 395.5 932C395.5 926.201 400.201 921.5 406 921.5Z"
              stroke="#1A1A1A"
            />
            <text
              fontFamily="Gilroy W05 Bold"
              fontSize={8}
              letterSpacing="2.8px"
              id="gene-label_28"
              fill="black"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
            >
              <tspan x={406.232} y={934.6}>
                APOC2
              </tspan>
            </text>
          </g>
          <g id="Apolipoprotein_6">
            <path
              d="M338 921.5H376C381.799 921.5 386.5 926.201 386.5 932C386.5 937.799 381.799 942.5 376 942.5H338C332.201 942.5 327.5 937.799 327.5 932C327.5 926.201 332.201 921.5 338 921.5Z"
              fill="white"
            />
            <path
              d="M338 921.5H376C381.799 921.5 386.5 926.201 386.5 932C386.5 937.799 381.799 942.5 376 942.5H338C332.201 942.5 327.5 937.799 327.5 932C327.5 926.201 332.201 921.5 338 921.5Z"
              stroke="#1A1A1A"
            />
            <text
              fontFamily="Gilroy W05 Bold"
              fontSize={8}
              letterSpacing="2.8px"
              id="gene-label_29"
              fill="black"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
            >
              <tspan x={343.054} y={934.6}>
                PON1
              </tspan>
            </text>
          </g>
          <g id="Apolipoprotein_7">
            <path
              d="M429 1012.5H467C472.799 1012.5 477.5 1017.2 477.5 1023C477.5 1028.8 472.799 1033.5 467 1033.5H429C423.201 1033.5 418.5 1028.8 418.5 1023C418.5 1017.2 423.201 1012.5 429 1012.5Z"
              fill="white"
            />
            <path
              d="M429 1012.5H467C472.799 1012.5 477.5 1017.2 477.5 1023C477.5 1028.8 472.799 1033.5 467 1033.5H429C423.201 1033.5 418.5 1028.8 418.5 1023C418.5 1017.2 423.201 1012.5 429 1012.5Z"
              stroke="#1A1A1A"
            />
            <text
              fontFamily="Gilroy W05 Bold"
              fontSize={8}
              letterSpacing="2.8px"
              id="gene-label_30"
              fill="black"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
            >
              <tspan x={429.17} y={1025.6}>
                APOC3
              </tspan>
            </text>
          </g>
          <g id="Apolipoprotein_8">
            <path
              d="M634 991.5H672C677.799 991.5 682.5 996.201 682.5 1002C682.5 1007.8 677.799 1012.5 672 1012.5H634C628.201 1012.5 623.5 1007.8 623.5 1002C623.5 996.201 628.201 991.5 634 991.5Z"
              fill="white"
            />
            <path
              d="M634 991.5H672C677.799 991.5 682.5 996.201 682.5 1002C682.5 1007.8 677.799 1012.5 672 1012.5H634C628.201 1012.5 623.5 1007.8 623.5 1002C623.5 996.201 628.201 991.5 634 991.5Z"
              stroke="#1A1A1A"
            />
            <text
              fontFamily="Gilroy W05 Bold"
              fontSize={8}
              letterSpacing="2.8px"
              id="gene-label_31"
              fill="black"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
            >
              <tspan x={634.17} y={1004.6}>
                APOC3
              </tspan>
            </text>
          </g>
          <g id="Apolipoprotein_9">
            <path
              d="M437 1051.5H475C480.799 1051.5 485.5 1056.2 485.5 1062C485.5 1067.8 480.799 1072.5 475 1072.5H437C431.201 1072.5 426.5 1067.8 426.5 1062C426.5 1056.2 431.201 1051.5 437 1051.5Z"
              fill="white"
            />
            <path
              d="M437 1051.5H475C480.799 1051.5 485.5 1056.2 485.5 1062C485.5 1067.8 480.799 1072.5 475 1072.5H437C431.201 1072.5 426.5 1067.8 426.5 1062C426.5 1056.2 431.201 1051.5 437 1051.5Z"
              stroke="#1A1A1A"
            />
            <text
              fontFamily="Gilroy W05 Bold"
              fontSize={8}
              letterSpacing="2.8px"
              id="gene-label_32"
              fill="black"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
            >
              <tspan x={437.459} y={1064.6}>
                APOA5
              </tspan>
            </text>
          </g>
          <g id="Apolipoprotein_10">
            <path
              d="M642 1030.5H680C685.799 1030.5 690.5 1035.2 690.5 1041C690.5 1046.8 685.799 1051.5 680 1051.5H642C636.201 1051.5 631.5 1046.8 631.5 1041C631.5 1035.2 636.201 1030.5 642 1030.5Z"
              fill="white"
            />
            <path
              d="M642 1030.5H680C685.799 1030.5 690.5 1035.2 690.5 1041C690.5 1046.8 685.799 1051.5 680 1051.5H642C636.201 1051.5 631.5 1046.8 631.5 1041C631.5 1035.2 636.201 1030.5 642 1030.5Z"
              stroke="#1A1A1A"
            />
            <text
              fontFamily="Gilroy W05 Bold"
              fontSize={8}
              letterSpacing="2.8px"
              id="gene-label_33"
              fill="black"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
            >
              <tspan x={642.459} y={1043.6}>
                APOA5
              </tspan>
            </text>
          </g>
          <g id="Apolipoprotein_11">
            <path
              d="M354 1050.5H392C397.799 1050.5 402.5 1055.2 402.5 1061C402.5 1066.8 397.799 1071.5 392 1071.5H354C348.201 1071.5 343.5 1066.8 343.5 1061C343.5 1055.2 348.201 1050.5 354 1050.5Z"
              fill="white"
            />
            <path
              d="M354 1050.5H392C397.799 1050.5 402.5 1055.2 402.5 1061C402.5 1066.8 397.799 1071.5 392 1071.5H354C348.201 1071.5 343.5 1066.8 343.5 1061C343.5 1055.2 348.201 1050.5 354 1050.5Z"
              stroke="#1A1A1A"
            />
            <text
              fontFamily="Gilroy W05 Bold"
              fontSize={8}
              letterSpacing="2.8px"
              id="gene-label_34"
              fill="black"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
            >
              <tspan x={358.499} y={1063.6}>
                APOE
              </tspan>
            </text>
          </g>
          <g id="Apolipoprotein_12">
            <path
              d="M78 1117.5H116C121.799 1117.5 126.5 1122.2 126.5 1128C126.5 1133.8 121.799 1138.5 116 1138.5H78C72.201 1138.5 67.5 1133.8 67.5 1128C67.5 1122.2 72.201 1117.5 78 1117.5Z"
              fill="white"
            />
            <path
              d="M78 1117.5H116C121.799 1117.5 126.5 1122.2 126.5 1128C126.5 1133.8 121.799 1138.5 116 1138.5H78C72.201 1138.5 67.5 1133.8 67.5 1128C67.5 1122.2 72.201 1117.5 78 1117.5Z"
              stroke="#1A1A1A"
            />
            <text
              fontFamily="Gilroy W05 Bold"
              fontSize={8}
              letterSpacing="2.8px"
              id="gene-label_35"
              fill="black"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
            >
              <tspan x={82.1984} y={1130.6}>
                APOB
              </tspan>
            </text>
          </g>
          <g id="Apolipoprotein_13">
            <path
              d="M76 1229.5H114C119.799 1229.5 124.5 1234.2 124.5 1240C124.5 1245.8 119.799 1250.5 114 1250.5H76C70.201 1250.5 65.5 1245.8 65.5 1240C65.5 1234.2 70.201 1229.5 76 1229.5Z"
              fill="white"
            />
            <path
              d="M76 1229.5H114C119.799 1229.5 124.5 1234.2 124.5 1240C124.5 1245.8 119.799 1250.5 114 1250.5H76C70.201 1250.5 65.5 1245.8 65.5 1240C65.5 1234.2 70.201 1229.5 76 1229.5Z"
              stroke="#1A1A1A"
            />
            <text
              fontFamily="Gilroy W05 Bold"
              fontSize={8}
              letterSpacing="2.8px"
              id="gene-label_36"
              fill="black"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
            >
              <tspan x={80.1984} y={1242.6}>
                APOB
              </tspan>
            </text>
          </g>
          <g id="Apolipoprotein_14">
            <path
              d="M328 1229.5H366C371.799 1229.5 376.5 1234.2 376.5 1240C376.5 1245.8 371.799 1250.5 366 1250.5H328C322.201 1250.5 317.5 1245.8 317.5 1240C317.5 1234.2 322.201 1229.5 328 1229.5Z"
              fill="white"
            />
            <path
              d="M328 1229.5H366C371.799 1229.5 376.5 1234.2 376.5 1240C376.5 1245.8 371.799 1250.5 366 1250.5H328C322.201 1250.5 317.5 1245.8 317.5 1240C317.5 1234.2 322.201 1229.5 328 1229.5Z"
              stroke="#1A1A1A"
            />
            <text
              fontFamily="Gilroy W05 Bold"
              fontSize={8}
              letterSpacing="2.8px"
              id="gene-label_37"
              fill="black"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
            >
              <tspan x={332.198} y={1242.6}>
                APOB
              </tspan>
            </text>
          </g>
          <g id="Apolipoprotein_15">
            <path
              d="M633 1299.5H671C676.799 1299.5 681.5 1304.2 681.5 1310C681.5 1315.8 676.799 1320.5 671 1320.5H633C627.201 1320.5 622.5 1315.8 622.5 1310C622.5 1304.2 627.201 1299.5 633 1299.5Z"
              fill="white"
            />
            <path
              d="M633 1299.5H671C676.799 1299.5 681.5 1304.2 681.5 1310C681.5 1315.8 676.799 1320.5 671 1320.5H633C627.201 1320.5 622.5 1315.8 622.5 1310C622.5 1304.2 627.201 1299.5 633 1299.5Z"
              stroke="#1A1A1A"
            />
            <text
              fontFamily="Gilroy W05 Bold"
              fontSize={8}
              letterSpacing="2.8px"
              id="gene-label_38"
              fill="black"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
            >
              <tspan x={637.198} y={1312.6}>
                APOB
              </tspan>
            </text>
          </g>
          <g id="Apolipoprotein_16">
            <path
              d="M559 1029.5H597C602.799 1029.5 607.5 1034.2 607.5 1040C607.5 1045.8 602.799 1050.5 597 1050.5H559C553.201 1050.5 548.5 1045.8 548.5 1040C548.5 1034.2 553.201 1029.5 559 1029.5Z"
              fill="white"
            />
            <path
              d="M559 1029.5H597C602.799 1029.5 607.5 1034.2 607.5 1040C607.5 1045.8 602.799 1050.5 597 1050.5H559C553.201 1050.5 548.5 1045.8 548.5 1040C548.5 1034.2 553.201 1029.5 559 1029.5Z"
              stroke="#1A1A1A"
            />
            <text
              fontFamily="Gilroy W05 Bold"
              fontSize={8}
              letterSpacing="2.8px"
              id="gene-label_39"
              fill="black"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
            >
              <tspan x={563.499} y={1042.6}>
                APOE
              </tspan>
            </text>
          </g>
          <g id="Apolipoprotein_17">
            <path
              d="M360 1011.5H398C403.799 1011.5 408.5 1016.2 408.5 1022C408.5 1027.8 403.799 1032.5 398 1032.5H360C354.201 1032.5 349.5 1027.8 349.5 1022C349.5 1016.2 354.201 1011.5 360 1011.5Z"
              fill="white"
            />
            <path
              d="M360 1011.5H398C403.799 1011.5 408.5 1016.2 408.5 1022C408.5 1027.8 403.799 1032.5 398 1032.5H360C354.201 1032.5 349.5 1027.8 349.5 1022C349.5 1016.2 354.201 1011.5 360 1011.5Z"
              stroke="#1A1A1A"
            />
            <text
              fontFamily="Gilroy W05 Bold"
              fontSize={8}
              letterSpacing="2.8px"
              id="gene-label_40"
              fill="black"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
            >
              <tspan x={360.771} y={1024.6}>
                APOC1
              </tspan>
            </text>
          </g>
          <g id="Apolipoprotein_18">
            <path
              d="M565 990.5H603C608.799 990.5 613.5 995.201 613.5 1001C613.5 1006.8 608.799 1011.5 603 1011.5H565C559.201 1011.5 554.5 1006.8 554.5 1001C554.5 995.201 559.201 990.5 565 990.5Z"
              fill="white"
            />
            <path
              d="M565 990.5H603C608.799 990.5 613.5 995.201 613.5 1001C613.5 1006.8 608.799 1011.5 603 1011.5H565C559.201 1011.5 554.5 1006.8 554.5 1001C554.5 995.201 559.201 990.5 565 990.5Z"
              stroke="#1A1A1A"
            />
            <text
              fontFamily="Gilroy W05 Bold"
              fontSize={8}
              letterSpacing="2.8px"
              id="gene-label_41"
              fill="black"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
            >
              <tspan x={565.771} y={1003.6}>
                APOC1
              </tspan>
            </text>
          </g>
          <g id="Apolipoprotein_19">
            <path
              d="M377 978.5H415C420.799 978.5 425.5 983.201 425.5 989C425.5 994.799 420.799 999.5 415 999.5H377C371.201 999.5 366.5 994.799 366.5 989C366.5 983.201 371.201 978.5 377 978.5Z"
              fill="white"
            />
            <path
              d="M377 978.5H415C420.799 978.5 425.5 983.201 425.5 989C425.5 994.799 420.799 999.5 415 999.5H377C371.201 999.5 366.5 994.799 366.5 989C366.5 983.201 371.201 978.5 377 978.5Z"
              stroke="#1A1A1A"
            />
            <text
              fontFamily="Gilroy W05 Bold"
              fontSize={8}
              letterSpacing="2.8px"
              id="gene-label_42"
              fill="black"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
            >
              <tspan x={377.232} y={991.6}>
                APOC2
              </tspan>
            </text>
          </g>
          <g id="Lipids_7">
            <g id="diamond_10">
              <path
                id="Vector 352_10"
                d="M366 909.325L390.501 885L415 909.325L402.75 932L390.5 932L378.25 932L366 909.325Z"
                fill="white"
                stroke="#1A1A1A"
              />
              <text
                fontFamily="Gilroy W05 Bold"
                fontSize={10}
                letterSpacing="0em"
                id="label_7"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
              >
                <tspan x={381.693} y={915.415}>
                  HDL
                </tspan>
              </text>
            </g>
          </g>
          <g id="Lipids_8">
            <g id="diamond_11">
              <path
                id="Vector 352_11"
                d="M290 1018.32L314.501 994L339 1018.32L326.75 1041L314.5 1041L302.25 1041L290 1018.32Z"
                fill="white"
                stroke="#1A1A1A"
              />
              <text
                fontFamily="Gilroy W05 Medium"
                fontSize={10}
                letterSpacing="0em"
                id="label_8"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
              >
                <tspan x={307.168} y={1024.41}>
                  LPL
                </tspan>
              </text>
            </g>
          </g>
          <g id="Lipids_9">
            <g id="diamond_12">
              <path
                id="Vector 352_12"
                d="M223 1098.32L247.501 1074L272 1098.32L259.75 1121L247.5 1121L235.25 1121L223 1098.32Z"
                fill="white"
                stroke="#1A1A1A"
              />
              <text
                fontFamily="Gilroy W05 Bold"
                fontSize={10}
                letterSpacing="0em"
                id="label_9"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
              >
                <tspan x={240.681} y={1104.42}>
                  IDL
                </tspan>
              </text>
            </g>
          </g>
          <g id="Lipids_10">
            <g id="diamond_13">
              <path
                id="Vector 352_13"
                d="M106 1145.32L130.501 1121L155 1145.32L142.75 1168L130.5 1168L118.25 1168L106 1145.32Z"
                fill="white"
                stroke="#1A1A1A"
              />
              <text
                fontFamily="Gilroy W05 Bold"
                fontSize={10}
                letterSpacing="0em"
                id="label_10"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
              >
                <tspan x={122.602} y={1151.42}>
                  LDL
                </tspan>
              </text>
            </g>
          </g>
          <g id="Lipids_11">
            <g id="diamond_14">
              <path
                id="Vector 352_14"
                d="M104 1254.32L128.501 1230L153 1254.32L140.75 1277L128.5 1277L116.25 1277L104 1254.32Z"
                fill="white"
                stroke="#1A1A1A"
              />
              <text
                fontFamily="Gilroy W05 Medium"
                fontSize={10}
                letterSpacing="0em"
                id="label_11"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
              >
                <tspan x={120.528} y={1260.41}>
                  LDL
                </tspan>
              </text>
            </g>
          </g>
          <g id="Lipids_12">
            <g id="diamond_15">
              <path
                id="Vector 352_15"
                d="M284 1254.32L308.501 1230L333 1254.32L320.75 1277L308.5 1277L296.25 1277L284 1254.32Z"
                fill="white"
                stroke="#1A1A1A"
              />
              <text
                fontFamily="Gilroy W05 Medium"
                fontSize={10}
                letterSpacing="0em"
                id="label_12"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
              >
                <tspan x={301.754} y={1260.41}>
                  IDL
                </tspan>
              </text>
            </g>
          </g>
          <g id="Lipids_13">
            <g id="diamond_16">
              <path
                id="Vector 352_16"
                d="M503 1249.32L527.501 1225L552 1249.32L539.75 1272L527.5 1272L515.25 1272L503 1249.32Z"
                fill="white"
                stroke="#1A1A1A"
              />
              <text
                fontFamily="Gilroy W05 Medium"
                fontSize={10}
                letterSpacing="0em"
                id="label_13"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
              >
                <tspan x={516.428} y={1255.41}>
                  Lp(a)
                </tspan>
              </text>
            </g>
          </g>
          <g id="Lipids_14">
            <g id="diamond_17">
              <path
                id="Vector 352_17"
                d="M588 1286.32L612.501 1262L637 1286.32L624.75 1309L612.5 1309L600.25 1309L588 1286.32Z"
                fill="white"
                stroke="#1A1A1A"
              />
              <text
                fontFamily="Gilroy W05 Medium"
                fontSize={10}
                letterSpacing="0em"
                id="label_14"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
              >
                <tspan x={601.428} y={1292.41}>
                  Lp(a)
                </tspan>
              </text>
            </g>
          </g>
          <g id="Lipids_15">
            <g id="diamond_18">
              <path
                id="Vector 352_18"
                d="M615 1236.32L639.501 1212L664 1236.32L651.75 1259L639.5 1259L627.25 1259L615 1236.32Z"
                fill="white"
                stroke="#1A1A1A"
              />
              <text
                fontFamily="Gilroy W05 Medium"
                fontSize={10}
                letterSpacing="0em"
                id="label_15"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
              >
                <tspan x={633.56} y={1242.41}>
                  TG
                </tspan>
              </text>
            </g>
          </g>
          <g id="Lipids_16">
            <g id="diamond_19">
              <path
                id="Vector 352_19"
                d="M808 1215.32L832.501 1191L857 1215.32L844.75 1238L832.5 1238L820.25 1238L808 1215.32Z"
                fill="white"
                stroke="#1A1A1A"
              />
              <text
                fontFamily="Gilroy W05 Medium"
                fontSize={10}
                letterSpacing="0em"
                id="label_16"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
              >
                <tspan x={824.787} y={1221.41}>
                  FFA
                </tspan>
              </text>
            </g>
          </g>
          <g id="Protein">
            <mask id="path-352-inside-1_18473_208764" fill="white">
              <path d="M164.645 1273C158.409 1273 152.958 1269.64 150 1264.64L158.635 1256L150 1247.37C152.958 1242.36 158.408 1239 164.645 1239C174.033 1239 181.645 1246.61 181.645 1256C181.645 1265.39 174.033 1273 164.645 1273Z" />
            </mask>
            <path
              d="M150 1264.64L149.293 1263.93L148.745 1264.48L149.139 1265.14L150 1264.64ZM158.635 1256L159.342 1256.71L160.049 1256L159.342 1255.29L158.635 1256ZM150 1247.37L149.139 1246.86L148.745 1247.52L149.293 1248.07L150 1247.37ZM164.645 1273L164.645 1272C158.777 1272 153.647 1268.84 150.861 1264.13L150 1264.64L149.139 1265.14C152.27 1270.44 158.04 1274 164.645 1274L164.645 1273ZM150 1264.64L150.707 1265.34L159.342 1256.71L158.635 1256L157.928 1255.29L149.293 1263.93L150 1264.64ZM158.635 1256L159.342 1255.29L150.707 1246.66L150 1247.37L149.293 1248.07L157.928 1256.71L158.635 1256ZM150 1247.37L150.861 1247.87C153.647 1243.16 158.777 1240 164.645 1240L164.645 1239L164.645 1238C158.04 1238 152.27 1241.56 149.139 1246.86L150 1247.37ZM164.645 1239L164.645 1240C173.481 1240 180.645 1247.16 180.645 1256L181.645 1256L182.645 1256C182.645 1246.06 174.586 1238 164.645 1238L164.645 1239ZM181.645 1256L180.645 1256C180.645 1264.84 173.481 1272 164.645 1272L164.645 1273L164.645 1274C174.586 1274 182.645 1265.94 182.645 1256L181.645 1256Z"
              fill="#1A1A1A"
              mask="url(#path-352-inside-1_18473_208764)"
            />
          </g>
          <g id="Protein_2">
            <mask id="path-354-inside-2_18473_208764" fill="white">
              <path d="M219.645 1305C213.409 1305 207.958 1301.64 205 1296.64L213.635 1288L205 1279.37C207.958 1274.36 213.408 1271 219.645 1271C229.033 1271 236.645 1278.61 236.645 1288C236.645 1297.39 229.033 1305 219.645 1305Z" />
            </mask>
            <path
              d="M205 1296.64L204.293 1295.93L203.745 1296.48L204.139 1297.14L205 1296.64ZM213.635 1288L214.342 1288.71L215.049 1288L214.342 1287.29L213.635 1288ZM205 1279.37L204.139 1278.86L203.745 1279.52L204.293 1280.07L205 1279.37ZM219.645 1305L219.645 1304C213.777 1304 208.647 1300.84 205.861 1296.13L205 1296.64L204.139 1297.14C207.27 1302.44 213.04 1306 219.645 1306L219.645 1305ZM205 1296.64L205.707 1297.34L214.342 1288.71L213.635 1288L212.928 1287.29L204.293 1295.93L205 1296.64ZM213.635 1288L214.342 1287.29L205.707 1278.66L205 1279.37L204.293 1280.07L212.928 1288.71L213.635 1288ZM205 1279.37L205.861 1279.87C208.647 1275.16 213.777 1272 219.645 1272L219.645 1271L219.645 1270C213.04 1270 207.27 1273.56 204.139 1278.86L205 1279.37ZM219.645 1271L219.645 1272C228.481 1272 235.645 1279.16 235.645 1288L236.645 1288L237.645 1288C237.645 1278.06 229.586 1270 219.645 1270L219.645 1271ZM236.645 1288L235.645 1288C235.645 1296.84 228.481 1304 219.645 1304L219.645 1305L219.645 1306C229.586 1306 237.645 1297.94 237.645 1288L236.645 1288Z"
              fill="#1A1A1A"
              mask="url(#path-354-inside-2_18473_208764)"
            />
          </g>
          <g id="Protein_3">
            <mask id="path-356-inside-3_18473_208764" fill="white">
              <path d="M273 1239C279.236 1239 284.686 1242.36 287.645 1247.36L279.01 1256L287.645 1264.63C284.686 1269.64 279.236 1273 273 1273C263.611 1273 256 1265.39 256 1256C256 1246.61 263.611 1239 273 1239Z" />
            </mask>
            <path
              d="M287.645 1247.36L288.352 1248.07L288.9 1247.52L288.505 1246.86L287.645 1247.36ZM279.01 1256L278.303 1255.29L277.596 1256L278.303 1256.71L279.01 1256ZM287.645 1264.63L288.505 1265.14L288.9 1264.48L288.352 1263.93L287.645 1264.63ZM273 1239V1240C278.868 1240 283.998 1243.16 286.784 1247.87L287.645 1247.36L288.505 1246.86C285.375 1241.56 279.604 1238 273 1238V1239ZM287.645 1247.36L286.937 1246.66L278.303 1255.29L279.01 1256L279.717 1256.71L288.352 1248.07L287.645 1247.36ZM279.01 1256L278.303 1256.71L286.937 1265.34L287.645 1264.63L288.352 1263.93L279.717 1255.29L279.01 1256ZM287.645 1264.63L286.784 1264.13C283.998 1268.84 278.868 1272 273 1272V1273V1274C279.604 1274 285.375 1270.44 288.505 1265.14L287.645 1264.63ZM273 1273V1272C264.163 1272 257 1264.84 257 1256H256H255C255 1265.94 263.059 1274 273 1274V1273ZM256 1256H257C257 1247.16 264.163 1240 273 1240V1239V1238C263.059 1238 255 1246.06 255 1256H256Z"
              fill="#1A1A1A"
              mask="url(#path-356-inside-3_18473_208764)"
            />
          </g>
          <g id="Lipids_17">
            <g id="diamond_20">
              <path
                id="Vector 352_20"
                d="M135 1030.32L159.501 1006L184 1030.32L171.75 1053L159.5 1053L147.25 1053L135 1030.32Z"
                fill="white"
                stroke="#1A1A1A"
              />
              <text
                fontFamily="Gilroy W05 Bold"
                fontSize={10}
                letterSpacing="0em"
                id="label_17"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
              >
                <tspan x={151.631} y={1036.42}>
                  FFA
                </tspan>
              </text>
            </g>
          </g>
          <g id="Lipids_18">
            <g id="diamond_21">
              <path
                id="Vector 352_21"
                d="M389 1043.32L413.501 1019L438 1043.32L425.75 1066L413.5 1066L401.25 1066L389 1043.32Z"
                fill="white"
                stroke="#1A1A1A"
              />
              <text
                fontFamily="Gilroy W05 Bold"
                fontSize={10}
                letterSpacing="0em"
                id="label_18"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
              >
                <tspan x={402.364} y={1049.42}>
                  VLDL
                </tspan>
              </text>
            </g>
          </g>
          <g id="Lipids_19">
            <g id="diamond_22">
              <path
                id="Vector 352_22"
                d="M594 1022.32L618.501 998L643 1022.32L630.75 1045L618.5 1045L606.25 1045L594 1022.32Z"
                fill="white"
                stroke="#1A1A1A"
              />
              <text
                fontFamily="Gilroy W05 Bold"
                fontSize={10}
                letterSpacing="0em"
                id="label_19"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
              >
                <tspan x={607.364} y={1028.42}>
                  VLDL
                </tspan>
              </text>
            </g>
          </g>
        </g>
      </g>
    </>
  );
};

const SvgCardiometabolicFatMetabolismDiagram = ({
  geneColors = {},
  expectedSnps = {},
  onGeneClick,
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={1024}
    height={1370}
    viewBox="0 184 1024 1370"
    fill="none"
    {...props}
  >
    <CardiometabolicFatMetabolismDiagramContent
      geneColors={geneColors}
      expectedSnps={expectedSnps}
      onGeneClick={onGeneClick}
    />
    <defs>
      <clipPath id="clip0_18473_208764">
        <rect width={1024} height={1554} fill="white" />
      </clipPath>
      <clipPath id="clip1_18473_208764">
        <rect width={1024} height={1370} fill="white" transform="translate(0 184)" />
      </clipPath>
    </defs>
  </svg>
);

export default SvgCardiometabolicFatMetabolismDiagram;
